/* GENERATED by cosmic/build_liquid.py from cosmic/spike/index.html.
   Do not edit here - edit the spike and re-run the build. */
const CXEL = document.getElementById('cx-config');
window.__cosmicConfig = JSON.parse(CXEL.textContent);
const CXA  = window.__cosmicConfig.assets;
// .cx-host blacks out the whole document (see the html,body rule).
// The banner is one block on somebody else's page, so it must not.
if ((window.__cosmicConfig.mode || '') !== 'banner')
  document.documentElement.classList.add('cx-host');

import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';

const hud = document.getElementById('cx-hud');
if (new URLSearchParams(location.search).get('hud') === '1')
  document.documentElement.classList.add('cx-showhud');
const log = [];
// hud is debug furniture and the banner build strips it out, so this must not
// assume it exists. It used to, and the resulting throw took out main() on the
// home page before a single frame rendered - a null textContent assignment
// killing the entire scene.
const say = (s) => { log.push(s); if (hud) hud.textContent = log.join('\n'); console.log(s); };

// ---- boot cover -------------------------------------------------------------
// FIRST thing in the module, ahead of the renderer. Two reasons, and the second
// is the important one:
//   - DefaultLoadingManager has to be hooked before anything starts loading, or
//     the first assets finish unreported;
//   - `new THREE.WebGLRenderer` THROWS on a device with no WebGL, at module top
//     level where main()'s catch cannot see it. With this block below that line,
//     bootReveal and its failsafe were never defined and the cover stayed up for
//     good: a permanently dark page, where before the cover you would at least
//     have seen the content. Everything below here may throw freely now.
const bootEl  = document.getElementById('cx-boot');
const bootBar = document.getElementById('cx-boot_bar');
// Cancels the CSS-only bail-out. From here the reveal is this module's job, and
// its failsafe below is armed whatever the rest of the module goes on to do.
if (bootEl) bootEl.classList.add('cx-boot-live');
// Held so the entry animation plays TO the visitor. The render loop starts well
// before main() finishes, so without this the moon rise, the type and the clock
// would all run out behind an opaque cover and the page would simply appear,
// already settled. entryTick keeps entryT0 null while this is true, so the
// choreography starts from zero at the reveal with its timing intact.
window.__bootHold = true;
let bootP = 0;
function bootSet(p){
  bootP = Math.max(bootP, Math.min(p, 1));     // monotonic: a bar that goes backwards reads as a fault
  if (!bootBar) return;
  bootBar.style.animation = 'none';            // take over from the CSS creep
  bootBar.style.transform = `scaleX(${bootP.toFixed(4)})`;
}
// Real counts, not a timer pretending to be progress: GLTFLoader, DRACOLoader and
// TextureLoader all report to DefaultLoadingManager when built without one of
// their own, which is how they are built above. It counts ITEMS, so this moves in
// five steps - honest, and the 0.15/0.85 ends leave room for the download of the
// module itself before it and the first render after it.
THREE.DefaultLoadingManager.onProgress = (_url, done, total) =>
  bootSet(0.15 + 0.70 * (total ? done / total : 0));

// WHEN to reveal. The full page reveals as soon as the scene has painted. The
// banner waits until it is actually ON SCREEN: it can sit well down the home
// page, and an entry animation that plays to an empty room is one the visitor
// never sees. Falls back to revealing immediately where IntersectionObserver
// is missing, because a banner that never uncovers is far worse than one whose
// animation was missed.
function armReveal(){
  if (!BANNER || !('IntersectionObserver' in window) || !HOST) {
    requestAnimationFrame(() => requestAnimationFrame(bootReveal));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    if (!entries.some(e => e.isIntersecting)) return;
    io.disconnect();
    requestAnimationFrame(() => requestAnimationFrame(bootReveal));
  }, { threshold: 0.25 });
  io.observe(HOST);
}

function bootReveal(){
  if (!window.__bootHold) return;              // once only
  window.__bootHold = false;                   // the entry animation starts on this line
  bootSet(1);
  if (bootEl){
    bootEl.classList.add('cx-boot-gone');
    setTimeout(() => { bootEl.hidden = true; }, 700);   // past the .55s fade
  }
}
window.__bootReveal = bootReveal;
// If the scene never becomes ready - no WebGL, a CDN that never answers, a throw
// inside main() - the cover still has to lift or the page is a dark rectangle for
// good. Reveal the hero only: showing all three panels is the exact stacking this
// cover exists to prevent.
setTimeout(() => {
  if (!window.__bootHold) return;
  console.warn('cosmic: scene not ready after 15s, revealing anyway');
  const first = document.querySelector('#cx-stage .cx-layer');
  if (first && !first.style.opacity){ first.style.opacity = '1'; first.style.visibility = 'visible'; }
  bootReveal();
}, 15000);

// ---- the host box -----------------------------------------------------------
// "The viewport" for this instance. On the full cosmic page #host is a fixed
// inset:0 div, so HW()/HH() are innerWidth/innerHeight to the pixel and nothing
// about that page changes. As a home-page banner it is the banner's own box, and
// the same code frames the same composition inside it.
// Everything that decides FRAMING reads these, never window: the renderer size,
// the camera aspect, the cover scale and the board->world unprojection. Leaving
// any one of them on innerWidth is the classic way to get a scene that is
// correctly sized and wrongly framed.
const HOST = document.getElementById('cx-host');
// 'banner' = the home-page hero: the same scene and the same hero composition,
// but it does NOT own the page. No scroll rig, no pager, no document-height
// assumptions - it is one block among a dozen others and must leave the page's
// own scrolling completely alone.
const BANNER = ((window.__cosmicConfig || {}).mode
                || new URLSearchParams(location.search).get('mode')) === 'banner';
window.__banner = BANNER;
const HW = () => HOST.clientWidth;
const HH = () => HOST.clientHeight;

const renderer = new THREE.WebGLRenderer({canvas:document.getElementById('cx-c'), antialias:true});
renderer.setPixelRatio(Math.min(devicePixelRatio,2));
renderer.setSize(HW(), HH());

// ---- render-loop lifecycle --------------------------------------------------
// WHY THIS EXISTS. setAnimationLoop was started once and never stopped. On the
// home page that meant the WebGL context kept rendering at 60fps after the
// banner had scrolled away, and kept going in a background tab. On a phone that
// is a live MSAA framebuffer at dpr 2 plus the GLB textures and the PMREM
// environment, held for the entire session, on top of ~40MB of decoded images
// and four autoplaying videos. It pushed tabs over their memory ceiling, so
// scrolling far enough got the tab killed and reloaded - which is exactly what
// was reported after this banner went live.
//
// The loop now runs only while the host is on screen AND the tab is visible.
// Full-page mode keeps rendering when scrolled (there the rig IS the page) but
// still stops when the tab is hidden. dt is already clamped in the loop, so a
// resume after a long pause cannot jump the animation.
let __loopFn = null, __loopRunning = false;
let __hostVisible = !BANNER;
const __rawSetLoop = renderer.setAnimationLoop.bind(renderer);
function __syncLoop() {
  const want = !!__loopFn && __hostVisible && !document.hidden;
  if (want === __loopRunning) return;
  __loopRunning = want;
  __rawSetLoop(want ? __loopFn : null);
}
renderer.setAnimationLoop = (fn) => { __loopFn = fn; __syncLoop(); };
document.addEventListener('visibilitychange', __syncLoop);
if (BANNER) {
  if ('IntersectionObserver' in window && HOST) {
    // rootMargin gives the scene a moment to resume before it scrolls back in,
    // so returning to the top never shows a frozen frame.
    new IntersectionObserver((entries) => {
      __hostVisible = entries.some((e) => e.isIntersecting);
      __syncLoop();
    }, { rootMargin: '250px 0px' }).observe(HOST);
  } else {
    __hostVisible = true;   // no IO support: behave as before rather than never render
    __syncLoop();
  }
}
// ---- the two boards ---------------------------------------------------------
// This page ships as a Shopify section, so ONE document is served to every
// device and the layout has to resolve in the browser. The DOM switch is pure
// CSS media query (both frames are emitted, the query picks one), and these are
// the matching numbers for the 3D rig, which CSS cannot reach.
//
// Deliberately a mutable object, not consts: a phone rotating, or a desktop
// window dragged across the breakpoint, has to re-derive rather than stay on
// whatever it booted with. VIEW.pick() is called from layout(), which already
// runs on resize.
//
// Desktop values are the LOCKED ones and must not drift - see index.desktop.lock.html.
const MQ_MOBILE = '(max-width: 700px)';
const VIEW = {
  d: { bw: 1440, bh: 818, hfov: 68.0 },
  m: { bw:  402, bh: 864, hfov: 68.0 },     // hfov tuned below once the moon is fitted
  isM: false, bw: 1440, bh: 818, hfov: 68.0,
  pick(){
    const m = matchMedia(MQ_MOBILE).matches;
    const changed = m !== this.isM;
    this.isM = m;
    Object.assign(this, m ? this.m : this.d);
    return changed;
  },
};
VIEW.pick();
window.__VIEW = VIEW;
// Mobile reads its OWN params for everything its look depends on, so a mobile
// tuning pass can never move desktop. ?m<name>= tunes mobile; desktop's plain
// ?<name>= is untouched and still only reaches desktop.
const vnum = (mName, mDef, dName, dDef) => VIEW.isM
  ? parseFloat(QP.get(mName) ?? mDef)
  : parseFloat(QP.get(dName) ?? dDef);
window.__vnum = vnum;
// One place that answers "how many screen px is a board px", used everywhere.
const boardScale = () => Math.max(HW()/VIEW.bw, HH()/VIEW.bh);
function layout(){
  const flipped = VIEW.pick();
  camera.aspect = HW()/HH();
  // derive vertical fov from a FIXED horizontal fov so width framing is stable
  const hf = THREE.MathUtils.degToRad(VIEW.hfov);
  camera.fov = THREE.MathUtils.radToDeg(2*Math.atan(Math.tan(hf/2)/camera.aspect));
  camera.updateProjectionMatrix();
  renderer.setSize(HW(), HH());
  // cover, so the frame never letterboxes
  document.documentElement.style.setProperty('--s', boardScale());
  document.documentElement.style.setProperty('--bw', VIEW.bw + 'px');
  document.documentElement.style.setProperty('--bh', VIEW.bh + 'px');
  // Crossing the breakpoint changes the board the rig is keyed to, so everything
  // positioned in board space has to be re-derived, not just rescaled.
  if (flipped && window.__viewFlip) window.__viewFlip();
  if (window.__anchorRocks) window.__anchorRocks();
  if (window.__placeClock) window.__placeClock();
}
addEventListener('resize', layout);
// The banner's box can change height without the window resizing at all - a
// section above it reflowing, a font swapping, the theme editor. Watch the box
// itself, not the window. Skipped on the full page, where the two are the same
// thing and the window event already covers it.
if (BANNER && 'ResizeObserver' in window && HOST) {
  let pw = 0, ph = 0;
  new ResizeObserver(() => {
    const w = HW(), h = HH();
    if (w === pw && h === ph) return;     // fires on paint-only changes too
    pw = w; ph = h;
    layout();
    if (window.__scrollDrive) window.__scrollDrive();
  }).observe(HOST);
}

// Board pixel -> world position at a chosen distance in front of the camera.
// The frame is scaled to COVER, so board coords map through that same scale
// before being unprojected.
function boardToWorld(bx, by, dist){
  camera.updateMatrixWorld(true);          // lookAt only set the quaternion
  const sc = boardScale();
  const w = HW(), h = HH();
  const sx = w/2 + (bx - VIEW.bw/2) * sc;
  const sy = h/2 + (by - VIEW.bh/2) * sc;
  const ndc = new THREE.Vector3((sx/w)*2 - 1, -((sy/h)*2 - 1), 0.5);
  ndc.unproject(camera);
  const dir = ndc.sub(camera.position).normalize();
  return camera.position.clone().add(dir.multiplyScalar(dist));
}
// ACES desaturates and hue-shifts, which fights authored colours. Togglable
// so the grade can be measured against the board rather than guessed.
const QP = new URLSearchParams(location.search);
// ?hfov= still overrides, and it overrides BOTH boards so a probe stays comparable.
if (QP.has('hfov')) VIEW.d.hfov = VIEW.m.hfov = parseFloat(QP.get('hfov'));
if (QP.has('mhfov')) VIEW.m.hfov = parseFloat(QP.get('mhfov'));
VIEW.pick();
renderer.toneMapping = QP.get('tm') === 'aces' ? THREE.ACESFilmicToneMapping
                     : QP.get('tm') === 'linear' ? THREE.LinearToneMapping
                     : THREE.NoToneMapping;    // default: authored colours survive
renderer.toneMappingExposure = parseFloat(QP.get('exp') || '1.15');

const scene  = new THREE.Scene(); window.__scene = scene; window.__THREE = THREE;
const camera = new THREE.PerspectiveCamera(parseFloat(QP.get('fov')||'42'), HW()/HH(), 0.1, 5000);

// ---- scroll rig -------------------------------------------------------------
// Per-section camera keyframes, one per sticky panel.
//
// The recording's hero -> surface handoff is a DESCENT, not a pitch. Measured off
// 21hrs.mov at 13.2-14.5s: the wordmark's bounding box stays EXACTLY 445x68px and
// never moves - the moon's limb rises up through the frame and swallows it from
// below, the view goes black, then resolves into lit surface. That only happens if
// the altitude collapses and the moon grows to engulf the camera.
//
// The old rig was one alt lerp plus a linear 180deg phi sweep driven by a single
// eased t. It could never produce this: the moon stayed the same size and the
// surface just slid in from the side. Altitude and pitch are keyframed per section
// instead, so the drop belongs to the handoff.
const MOON_R = 34;

// phi is measured FROM the outward radial:
//   0        looking straight up, away from the moon
//   90 + dip looking exactly at the horizon (dip = horizon dip for this altitude)
//   180      looking straight down at the surface
// `over` is degrees PAST the horizon. Stated that way rather than as an absolute
// angle so a section keeps its framing while the altitude changes - the dip is
// recomputed from the interpolated altitude every frame.
//
// Each key also carries its own SUN direction. The hero's sun sits behind the
// moon (-Z) because that is what gives the board its rim-lit crescent - but the
// camera descends along +Z, so the landing site is on the night side and the
// surface section came out unlit: mean luminance 15, a smooth dark blur with no
// crater relief no matter how much normal detail was layered on. Rather than
// swing the camera ~180deg of longitude to find daylight, the key light travels
// with the section. It is a stage light on a designed page, and the surface key
// is deliberately grazing (about 17deg above the local horizon) because long
// shadows are what make craters read.
// sx/sy/sz set the HERO sun, s2x/s2y/s2z the surface, s3x/s3y/s3z the watch.
// Each axis is independent: passing only s2y now works. It used to not - the
// keyframe override was gated on QP.has('sx') alone, so any of the other five
// were written once at startup and then overwritten on the first frame.
// A static sun is just the same vector in all three sections.
const sunDir = (p, dx, dy, dz) => [
  parseFloat(QP.get(p + 'x') ?? String(dx)),
  parseFloat(QP.get(p + 'y') ?? String(dy)),
  parseFloat(QP.get(p + 'z') ?? String(dz)),
];
const RIG_KEYS = [
  // Sun DIRECTION per section is a vector; only its direction matters, it gets
  // renormalised to a fixed distance so intensity does not drift with magnitude.
  { alt: parseFloat(QP.get('alt')  || '24.6'), over: parseFloat(QP.get('over1') || '0'),
    sun: sunDir('s',    0,  0, -78), sunI: parseFloat(QP.get('sun')  || '26.0'),
    bak: sunDir('b',   70, 30,  12), bakI: parseFloat(QP.get('back') || '2.0'), lon: parseFloat(QP.get('lon1') || '0') },  // hero: behind the moon, rim-lit limb
  { alt: parseFloat(QP.get('alt2') || '2.6'),  over: parseFloat(QP.get('over2') || '68'),
    sun: sunDir('s2',   0,  0, -78), sunI: parseFloat(QP.get('sun2') || '0.8'),
    bak: sunDir('b2', -70, 35,   8), bakI: parseFloat(QP.get('back2')|| '0.4'), lon: parseFloat(QP.get('lon2') || '0') },  // surface: grazing the landing site
  { alt: parseFloat(QP.get('alt3') || '9.0'),  over: parseFloat(QP.get('over3') || '170'),
    sun: sunDir('s3',   0,  0, -78), sunI: parseFloat(QP.get('sun3') || '26.0'),
    bak: sunDir('b3',  38, 40, -52), bakI: parseFloat(QP.get('back3')|| '2.0'), lon: parseFloat(QP.get('lon3') || '0') },  // watch: back to a rim
];
// t in [0,1] spans the keyframes evenly. The scroll handler holds t at these
// anchors while a section is pinned and only travels between them.
window.__rigKeys = RIG_KEYS;
// Mobile hero: the board shows a far bigger, higher moon - disc radius 443 board
// px on a 402-wide board, limb crossing at y=369. That is a much lower altitude
// than desktop's 24.6. Fitted below against the board; ?malt=/?mover= to retune.
if (VIEW.isM) {
  RIG_KEYS[0].alt  = parseFloat(QP.get('malt')  || '7.0');
  // 11.1 is fitted, not chosen. alt barely moves the limb here - phi already
  // compensates for dip, so the rig holds the horizon steady by design and the
  // pitch is what raises it. Swept against the board's limb at seven columns:
  // over 10.5 sat 3.4px low, 11.75 sat 3.3px high, so the crossing is 11.1.
  RIG_KEYS[0].over = parseFloat(QP.get('mover') || '11.1');
  // Sun and fill keep the SIGNED-OFF desktop geometry - sun straight behind,
  // fill round at 70,30,12 - because that is what makes this moon read violet.
  // Swinging the sun up and round to +80Y did fit the board's luminance profile
  // better on paper (rms 32.6 against 67) and was WRONG: a direct sun blows the
  // violet albedo out to grey specular, and the board's moon is deep violet.
  // Luminance alone is not a sufficient metric here; chroma has to be checked too.
  // Mobile therefore differs from desktop only in EXPOSURE, via mhemi/menv below.
  RIG_KEYS[0].sun  = sunDir('ms', 0, 0, -78);
  RIG_KEYS[0].sunI = parseFloat(QP.get('msun')  || '26.0');
  RIG_KEYS[0].bak  = sunDir('mb', 70, 30,  12);
  // 1.2, not desktop's 2. At alt 7 the camera is close enough that the fill alone
  // carried the surface to mean 20.3; ambient was not the lever (16.2 -> 14.5
  // across a 4x cut), the fill was. 0.1 matched the board's measured 3.83 and was
  // far too dark to look at - the board is an AI render, not the arbiter.
  RIG_KEYS[0].bakI = parseFloat(QP.get('mback') || '1.2');
}
const PANEL_T = RIG_KEYS.map((_, i) => i / (RIG_KEYS.length - 1));

// Camera sits over the EQUATOR, not the pole. A UV sphere's equirect mapping
// converges to a singularity at the poles, so looking straight down at one
// produces visible radial streaking in the tiled crater map.
// The camera also travels in LONGITUDE between sections. Without it the rig only
// slid in and out along +Z, which meant one knob (moonlon) had to choose both the
// face shown at the hero and the terrain landed on at the surface - and those want
// opposite things. The near side is recognisable BECAUSE of the maria, and maria
// are flat lava plains with almost no craters: landing there measured 0.891 relief
// against 3.098 a quarter turn away, under identical light.
const UP_AXIS = new THREE.Vector3(0, 1, 0);
const TANGENT = new THREE.Vector3(0, 1, 0);   // the direction the pitch sweeps through
const RADIAL  = new THREE.Vector3(0, 0, 1);   // outward from moon centre, at longitude 0
const PHI_LEAD = THREE.MathUtils.degToRad(parseFloat(QP.get('lead') || '0'));
// Light directions are authored in each section's OWN radial frame: +z points
// away from the moon at that section's longitude, x/y are the local horizon.
// So sz=-78 means "behind the moon from here" and b2z=8 means "8 above the local
// horizon" wherever the camera has travelled to. Rotate them into world space
// once, per keyframe, rather than interpolating raw then rotating - otherwise the
// light swings through the wrong arc during a handoff.
for (const k of RIG_KEYS) {
  const rot = THREE.MathUtils.degToRad(k.lon), Y = new THREE.Vector3(0,1,0);
  k.sunW = new THREE.Vector3(...k.sun).applyAxisAngle(Y, rot).toArray();
  k.bakW = new THREE.Vector3(...k.bak).applyAxisAngle(Y, rot).toArray();
}
const lerp = (a,b,t) => a + (b-a)*t;
// Kept for tuning, but nothing eases the rig any more: the scroll pager owns the
// easing now and applying a second one here compounded into a lunge. See rigT.
const easeInOut = t => t<0.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2;   // eslint-disable-line no-unused-vars
const easeOutCubic = u => 1 - Math.pow(1 - u, 3);
const clamp01 = v => v < 0 ? 0 : v > 1 ? 1 : v;

// ---- the shape every section enters and leaves with --------------------------
// p is the panel's own opacity: 0 parked, 1 settled. Content travels less than
// the lines do, so ONE mapping gives both orders - entering, the content lands
// first and the lines are still extending; leaving, the lines go first and the
// content is last out. That is the hero's choreography, reused verbatim.
//
// Easing is ease-out in the DIRECTION OF TRAVEL, not a literal reversal. A
// reversed ease-out is an ease-in, which back-loads every pixel of travel into
// the part of the fade that is nearly transparent, where nobody can see it.
// A section's whole entry is ~750ms, where the hero's is 2.4 SECONDS, so the
// hero's 0.625 split leaves the content rise far too short to register - measured,
// 117ms. Sections give the content 0.85 of their window and keep the stagger in
// the last 15%, which is the most that fits.
const TFRAC = 0.85;           // content's share of the window
function sectionSettle(p, entering, tf = TFRAC){
  if (entering) return { text: easeOutCubic(clamp01(p / tf)), line: easeOutCubic(p) };
  const e = 1 - p;
  return { text: 1 - easeOutCubic(clamp01((e - (1 - tf)) / tf)),
           line: 1 - easeOutCubic(e) };
}

// Some board elements carry an optical offset of their own - #p3_change is nudged
// 21px right - so the rise has to COMPOSE with that rather than overwrite it.
// Read once, before anything of ours has been written to the element.
function baseTf(el){
  if (el.__baseTf === undefined) {
    const t = getComputedStyle(el).transform;
    el.__baseTf = (t && t !== 'none') ? t + ' ' : '';
  }
  return el.__baseTf;
}

function applyScroll(t){
  t = THREE.MathUtils.clamp(t, 0, 1);
  // Which keyframe pair, and how far through it. LINEAR here on purpose: the
  // scroll handler's rigT() already eases the handoff, and easing in both places
  // compounded into a crawl at each end.
  const last = RIG_KEYS.length - 1;
  const seg = Math.min(Math.floor(t * last), last - 1);
  const span = PANEL_T[seg+1] - PANEL_T[seg];
  const f = span > 0 ? (t - PANEL_T[seg]) / span : 0;
  const A = RIG_KEYS[seg], B = RIG_KEYS[seg+1];

  const alt = lerp(A.alt, B.alt, f) + (window.__entryMoon || 0);
  const r = MOON_R + alt;
  // radial and camera-right rotate with longitude; the pitch plane stays N-S
  const RAD = RADIAL.clone().applyAxisAngle(UP_AXIS, THREE.MathUtils.degToRad(lerp(A.lon, B.lon, f)));
  const AXIS = TANGENT.clone().cross(RAD).normalize();
  camera.position.copy(RAD).multiplyScalar(r); window.__camera = camera;

  const dip = Math.acos(THREE.MathUtils.clamp(MOON_R / r, -1, 1));
  const phi = (Math.PI/2 + dip - PHI_LEAD) + THREE.MathUtils.degToRad(lerp(A.over, B.over, f));

  // key light travels with the section; renormalised so intensity does not drift
  if (window.__sun) {
    const S = window.__sun.position;
    S.set(lerp(A.sunW[0], B.sunW[0], f), lerp(A.sunW[1], B.sunW[1], f), lerp(A.sunW[2], B.sunW[2], f))
     .normalize().multiplyScalar(80);
    // Intensity travels too. 26 is fitted to the hero, where the sun is BEHIND
    // the moon and only grazes the limb. Pointed at the landing site it is a
    // direct key and blew the surface to mean luminance 168; the board's own
    // frame 2 surface measures mean 11.7, p95 38 - near black with fine relief.
    window.__sun.intensity = lerp(A.sunI, B.sunI, f);
  }
  // The fill light travels too. It has to: at the surface section the camera is
  // straight above the landing point, so a light on the view axis lands at
  // dot(N,L)=1 and casts no shadows in any direction. Craters only read at a
  // grazing angle, so whichever light is doing the lifting there must come in
  // low. Keeping it fixed is what flattens that section.
  if (window.__back) {
    const Bk = window.__back.position;
    Bk.set(lerp(A.bakW[0], B.bakW[0], f), lerp(A.bakW[1], B.bakW[1], f), lerp(A.bakW[2], B.bakW[2], f))
      .normalize().multiplyScalar(80);
    window.__back.intensity = lerp(A.bakI, B.bakI, f);
  }

  const fwd = RAD.clone().multiplyScalar(Math.cos(phi))
              .add(TANGENT.clone().multiplyScalar(Math.sin(phi))).normalize();
  const up  = fwd.clone().applyAxisAngle(AXIS, Math.PI/2).normalize();

  camera.up.copy(up);
  camera.lookAt(camera.position.clone().add(fwd));
  window.__scrollT = t;
  if (window.__rockVis) window.__rockVis();
}

// BAKED FROM THE SIGNED-OFF DESKTOP URL, 2026-09-19. These had only ever existed
// as query params, so a plain load rendered a look nobody was using - in the
// Shopify port it showed as an unfamiliar, differently-lit moon face.
//   sx/sy/sz = s2* = s3* = 0,0,-78    back=2   bx,by,bz = 70,30,12   back3=2
//   glow=0.2   dens=3   thick=12   cenv=1.4    (crough and rscale already matched)
// Mobile is NOT affected: it reads its own m-prefixed params for the hero's sun,
// fill and glow. ?isolate=1 was in that URL too and is a DEAD param - nothing
// reads it.
// one hard sun, no fill: vacuum lighting
const sun = new THREE.DirectionalLight(0xfff5ee, RIG_KEYS[0].sunI);
// Position and intensity are owned by applyScroll(), which interpolates the
// per-section keyframes above. This is just the starting value.
sun.position.set(...RIG_KEYS[0].sunW);
scene.add(sun); window.__sun = sun;

// violet hemisphere standing in for the moon's albedo bounce.
// without this the crystals render black, exactly as they did in Blender.
// rim light sitting behind the moon: gives the limb its halo without lifting
// the face, which a single key could never do at the same time
const backLight = new THREE.DirectionalLight(
  new THREE.Color(QP.get('back_col') || '#b566ff'), RIG_KEYS[0].bakI);
// Position and intensity owned by applyScroll(); this is the starting value.
backLight.position.set(...RIG_KEYS[0].bakW);
scene.add(backLight); window.__back = backLight;

// ---- mobile: a real light that grazes the limb ------------------------------
// The shader rim could be centred on the limb but never stopped reading as a
// drawn band - it is an emissive term, so it ignores the terrain and flattens
// whatever it covers. This is an actual directional light placed so its
// terminator falls on the visible limb, which means the craters there get lit
// and shade themselves.
//
// Its direction has to TRACK the camera for the same reason the rim centre did.
// The visible limb sits at theta = acos(R/d) from the sub-camera point, so the
// direction that grazes it is perpendicular to that normal, in the view's
// vertical plane:  L = (0, R/d, -sqrt(1 - (R/d)^2)).
// At d=41 that is (0, 0.829, -0.559); at the entry's d=71, (0, 0.479, -0.878).
// Fixed, it would light the middle of the disc for most of the fly-in.
let limbLight = null;
if (VIEW.isM) {
  limbLight = new THREE.DirectionalLight(
    new THREE.Color(QP.get('mlimb_col') || '#c9a0ff'),
    parseFloat(QP.get('mlimb') || '3.0'));
  scene.add(limbLight);
  // +ve bias swings the light further behind, pushing the lit band outward to
  // the very edge; -ve brings it round to the front and widens it inward.
  const LB = THREE.MathUtils.degToRad(parseFloat(QP.get('mlimbbias') || '-4'));
  window.__limbTrack = () => {
    const d = Math.max(camera.position.length(), MOON_R + 0.01);
    const th = Math.acos(Math.min(1, MOON_R / d)) + Math.PI/2 + LB;
    limbLight.position.set(0, Math.sin(th), Math.cos(th)).multiplyScalar(80);
  };
  window.__limbTrack();
  window.__limbLight = limbLight;
}

// ---- virtual per-crystal lights ------------------------------------------
// three.js layers do NOT isolate lights: in the forward renderer every light hits
// every visible object regardless of layer (verified - moon on layer 0 was still
// lit 20 -> 193 by a light on layer 1). So each rock carries its OWN light as a
// shader uniform instead. Real scene lights never touch the rocks, and these
// never touch the moon.
const CL_INT = [0.1, 0.1, 0.1, 0.1, 0.1, 0.1];
const VLIGHTS = [];
for (let i = 0; i < 6; i++) {
  const n = i + 1;
  VLIGHTS.push({
    pos: new THREE.Vector3(
      parseFloat(QP.get(`cl${n}x`) ?? (i % 2 === 0 ? '-24' : '24')),
      parseFloat(QP.get(`cl${n}y`) ?? '12'),
      parseFloat(QP.get(`cl${n}z`) ?? '20')),
    col: new THREE.Color(QP.get(`cl${n}_col`) || '#7d3bd6'),
    // front fill, on the same camera->rock axis but on the CAMERA side. The back
    // light only reveals what the rock transmits; facets facing the viewer stay
    // black without this.
    fpos: new THREE.Vector3(),
    fcol: new THREE.Color(QP.get(`cl${n}f_col`) || QP.get(`cl${n}_col`) || '#7d3bd6'),
    // Off by default. It lifts the viewer-facing facets, but once the back light
    // carries the internal rays it only flattens them - it raises exactly the
    // darks the structure depends on. Kept as a knob.
    fint: parseFloat(QP.get(`cl${n}f`) ?? '0.0'),
    // 0.02 is where cl1/cl2 were tuned to. The old 0.55 default blew the four
    // later-panel crystals out to flat emissive purple.
    // Per rock so any one can be pulled out later, but all six are on the same
    // value. 0.02 was too low to show the internal structure at all; 1.0 lit them
    // up as bright gems that competed with the clock and the watch. 0.1 keeps them
    // as dark chips with the rays just reading.
    int: parseFloat(QP.get(`cl${n}`) ?? String(CL_INT[i] ?? 1.0)),
    manual: QP.has(`cl${n}x`) || QP.has(`cl${n}y`) || QP.has(`cl${n}z`),
  });
}
window.__vlights = VLIGHTS;

scene.add(new THREE.HemisphereLight(
  new THREE.Color(QP.get('hemi_col') || '#a074d0'), 0x05030a,
  vnum('mhemi', '0.02', 'hemi', '0.06')));

function buildEnvironment(renderer){
  const cv = document.createElement('canvas');
  cv.width = 256; cv.height = 128;
  const x = cv.getContext('2d');
  // violet hemisphere (the moon's albedo bounce) over near-black space
  const g = x.createLinearGradient(0,0,0,128);
  g.addColorStop(0.00,'#07040f');
  g.addColorStop(0.42,'#140a24');
  g.addColorStop(0.68,'#3a1866');
  g.addColorStop(0.88,'#6a2fa8');
  g.addColorStop(1.00,'#8c49c6');
  x.fillStyle=g; x.fillRect(0,0,256,128);
  // the sun: a small hot disc, so speculars have something to catch
  const sg = x.createRadialGradient(188,34,0,188,34,26);
  sg.addColorStop(0,'#ffffff'); sg.addColorStop(0.35,'#fff2e2'); sg.addColorStop(1,'rgba(0,0,0,0)');
  x.fillStyle=sg; x.beginPath(); x.arc(188,34,26,0,Math.PI*2); x.fill();
  const tex = new THREE.CanvasTexture(cv);
  tex.mapping = THREE.EquirectangularReflectionMapping;
  tex.colorSpace = THREE.SRGBColorSpace;
  const pmrem = new THREE.PMREMGenerator(renderer);
  pmrem.compileEquirectangularShader();
  const env = pmrem.fromEquirectangular(tex).texture;
  pmrem.dispose(); tex.dispose();
  return env;
}
scene.environment = buildEnvironment(renderer);
scene.environmentIntensity = vnum('menv', '0.08', 'env', '0.25');

const draco = new DRACOLoader().setDecoderPath('https://cdn.jsdelivr.net/npm/three@0.169.0/examples/jsm/libs/draco/');
const gltf  = new GLTFLoader().setDRACOLoader(draco);
const texl  = new THREE.TextureLoader();

const load = (u) => new Promise((res,rej)=>gltf.load(u,res,undefined,rej));
const tex  = (u) => new Promise((res,rej)=>texl.load(u,res,undefined,rej));

// ---------- shared GLSL: cheap worley for the sub-DEM crater detail ----------
const NOISE = `
vec3 hash3(vec3 p){
  p = vec3(dot(p,vec3(127.1,311.7,74.7)), dot(p,vec3(269.5,183.3,246.1)), dot(p,vec3(113.5,271.9,124.6)));
  return fract(sin(p)*43758.5453123);
}
// Worley returning BOTH the distance and the winning cell's hash, so each cell
// can decide its own crater size - or decide it has no crater at all. Plain F1
// makes every cell a crater of identical size, which reads as a honeycomb.
vec2 worleyCell(vec3 p){
  vec3 i = floor(p), f = fract(p);
  float d = 1e9; float id = 0.0;
  for(int x=-1;x<=1;x++) for(int y=-1;y<=1;y++) for(int z=-1;z<=1;z++){
    vec3 g = vec3(float(x),float(y),float(z));
    vec3 o = hash3(i+g);
    float dist = length(g+o-f);
    if(dist < d){ d = dist; id = fract(dot(i+g, vec3(12.9898,78.233,37.719))*43758.5453); }
  }
  return vec2(d, id);
}
float craters(vec3 p, float scale){
  vec2 w = worleyCell(p*scale);
  float d = w.x, id = w.y;
  // ~45% of cells carry a crater; the rest stay as plain regolith
  if(id < 0.55) return 0.0;
  float r = mix(0.16, 0.40, fract(id*7.31));   // per-cell radius
  float depth = mix(0.35, 1.0, fract(id*3.77));
  float bowl = -smoothstep(0.0, r, d) * 0.85 * depth;
  float rim  = exp(-pow((d-r)/(r*0.34), 2.0)) * 0.45 * depth;
  return bowl + rim;
}`;

async function main(){
  let t0 = performance.now();
  const Q = new URLSearchParams(location.search);
  const MODE = Q.get('mode') || 'vertex';          // vertex | lossless | baked
  const moonUrl = MODE === 'baked' ? CXA.moon : CXA.moon;
  const hUrl = CXA.moonHeight;
  const [sphereGltf, crystalsGltf, hMap, cMap, tileN] = await Promise.all([
    load(moonUrl),
    load(Q.get('rock')==='old' ? CXA.crystals
         : Q.get('rock')==='det' ? CXA.crystals
         : CXA.crystals),
    tex(hUrl),
    tex(CXA.moonColor),
    tex(CXA.craterNormal),
  ]);
  say('mode: ' + MODE);
  say(`assets loaded in ${Math.round(performance.now()-t0)}ms`);

  for (const t of [hMap,cMap]){
    t.wrapS = THREE.RepeatWrapping;
    // Equirect source has row 0 = NORTH pole. three's SphereGeometry has v=0 at
    // the SOUTH pole, so flipY=false loads these upside down and inverts the
    // north-south slope - which renders every crater as a dome.
    t.flipY = (Q.get('flipy') === '0') ? false : true;
  }
  hMap.generateMipmaps = false;
  hMap.minFilter = THREE.LinearFilter;
  hMap.magFilter = THREE.LinearFilter;
  tileN.wrapS = tileN.wrapT = THREE.RepeatWrapping;
  tileN.flipY = false;
  tileN.colorSpace = THREE.NoColorSpace;
  cMap.colorSpace = THREE.SRGBColorSpace;
  hMap.colorSpace = THREE.NoColorSpace;

  // ---------------- MOON ----------------
  let moonMesh = null;
  sphereGltf.scene.traverse(o=>{ if(o.isMesh) moonMesh = o; });
  if(!moonMesh){ say('FAIL: no mesh in moon_sphere.glb'); return; }
  const pos = moonMesh.geometry.getAttribute('position');
  say(`moon sphere: ${pos.count} verts, uv=${!!moonMesh.geometry.getAttribute('uv')}`);

  const moonMat = new THREE.MeshStandardMaterial({ map: cMap, roughness: 0.97, metalness: 0.0 });
  moonMat.userData.u = {
    uHeight:  { value: hMap },
    uDisp:    { value: MODE === 'baked' ? 0.0 : (Q.has('disp') ? parseFloat(Q.get('disp')) : 0.010) },
    uDetail:  { value: Q.has('detail') ? parseFloat(Q.get('detail')) : 1.0 },
    uTile:    { value: tileN },
    uRimCol:  { value: new THREE.Color(0.78, 0.36, 1.00) },   // measured 0.95:0.68:1, near-white
    // Refitted against the board's own Moon.png, which is far better ground truth
    // than Hero.png was. Measured N.V vs inward screen distance with ?ndv=1: N.V
    // runs 0.329 -> 0.663 in the first FOUR pixels, then only 0.663 -> 0.775 over
    // the next 216, so the whole rim lives in a narrow window near 0.68. The old
    // 0.30 put the peak at the silhouette itself, which is why the edge read dull
    // and abrupt. The comment below this already said the centre was 0.708; the
    // value was simply never applied.
    // Centre must sit INSIDE the view's own N.V range or the term never fires.
    // Measured with ?ndv=1: desktop's surface runs N.V 0.898 at the limb to 0.969
    // deep in, mobile's 0.929 to 1.000. The fitted 0.676 is below both, so the
    // gaussian branch is dead and only the power tail runs - which evaluates to
    // 0.002 at desktop's limb and 0.0002 at mobile's. Mobile re-centres onto its
    // own limb value so the rim actually lands on the first pixels inside it.
    // mrimp is 16, not desktop's 5.35: u = (ndv-ctr)/(1-ctr) now spans mobile's
    // whole visible surface in 0.071 of N.V, so a slow tail floods the entire
    // disc instead of banding the edge. mrimw widens the gaussian enough to meet
    // the outward glow - too narrow and the two read as separate rings with a
    // dark line between them.
    uRimCtr:  { value: vnum('mrimctr', '0.929', 'rimctr', '0.676') },   // mobile: retracked per frame, see __rimTrack
    uRimW:    { value: vnum('mrimw', '0.030', 'rimw', '0.120') },   // gaussian rise, fitted to 13/205 at the silhouette
    // 2.2 with the refitted shape drove the peak to 247 and CLIPPED: the band went
    // flat-topped, which is what read as a hard edge. 1.1 peaks at ~222 against the
    // board's 217 and keeps the gradient.
    // mobile uses a real grazing light instead of the shader rim, see __limbLight
    uRimStr:  { value: vnum('mrim', '0.0', 'rim', '1.1') },
    uRimTail: { value: parseFloat(Q.get('rimtail')|| '4.2') },
    uRimTailM:{ value: parseFloat(Q.get('rimtm')  || '0.35') },
    uRimDbg:  { value: Q.get('ndv')==='1' ? 1.0 : 0.0 },
    uRimTerr: { value: parseFloat(Q.get('rimterr') || '0.7') },  // how much terrain modulates the rim
    uRimPowIn:{ value: vnum('mrimp', '16.0', 'rimp', '5.35') }, // inward falloff, least-squares fit to Moon.png
    uTileRep: { value: parseFloat(Q.get('rep') || '14.0') },
    uTileAmt: { value: parseFloat(Q.get('tile') || '0.08') },   // procedural detail, now a top-up only
    // DEM slope exaggeration. 0.55 rendered the hero moon nearly flat: local
    // contrast (high-pass std / mean) came out 0.239 against the board's 0.292.
    // 1.9 matches it at 0.288. The procedural tile barely moves this at hero
    // distance - 0.08 vs 0.25 changed HF by 2% - so relief is the control.
    uRelief:  { value: parseFloat(Q.get('relief') || '1.9') },
    uTexel:   { value: new THREE.Vector2(1/4096, 1/2048) },
    uKmSpan:  { value: 19.67 },
    // Close-range detail. At the surface section the camera is 2.6 units above a
    // radius-34 sphere: the 4096x2048 equirect gives ~38 texels across the whole
    // screen height, so the albedo reads as compression blocks and the 14-repeat
    // crater tile is magnified ~4x. This is a second, much finer sample of the
    // SAME tile, faded in by camera distance. The UVs are static, so nothing
    // swims during the descent - only the blend weight moves.
    uDetMul:  { value: parseFloat(Q.get('detmul') || '9.0') },
    uDetAmt:  { value: parseFloat(Q.get('detamt') || '0.9') },
    uDetAlb:  { value: parseFloat(Q.get('detalb') || '0.16') },
    uDetNear: { value: parseFloat(Q.get('detnear')|| '2.0') },
    uDetFar:  { value: parseFloat(Q.get('detfar') || '18.0') },
    uSgnU:    { value: parseFloat(Q.get('su') || '1') },
    uSgnV:    { value: parseFloat(Q.get('sv') || '1') },                                 // DEM range in km, for slope maths
  };
  moonMat.onBeforeCompile = (sh) => {
    setTimeout(()=>{ window.__moonFrag = sh.fragmentShader; },0);
    Object.assign(sh.uniforms, moonMat.userData.u);
    sh.vertexShader = sh.vertexShader
      .replace('#include <common>', `#include <common>
        uniform sampler2D uHeight; uniform float uDisp;
        varying vec3 vObjPos; varying vec3 vWPos; varying vec3 vDispNormal;
        varying vec2 vTileUv; uniform float uTileRep;
        varying vec3 vWorldPos; varying vec3 vWorldNrm; varying vec2 vMoonUv;
        varying vec3 vFragW;`)
      .replace('#include <begin_vertex>', `
        float h = textureLod(uHeight, uv, 0.0).r - 0.5;
        vec3 transformed = position + normal * h * uDisp;
        vObjPos = transformed;
        // Equirect UV is 2:1 (u spans 360 deg, v spans 180), so a SQUARE tile
        // mapped with equal repeat comes out stretched 2x wide - every crater
        // reads as an ellipse. Double the u repeat to compensate.
        vTileUv = vec2(uv.x * uTileRep * 2.0, uv.y * uTileRep);
        vMoonUv = uv;
        // DELIBERATE: vWorldPos is assigned from vWPos BEFORE vWPos is computed
        // below, so it does not carry this fragment's world position. That is a
        // bug, but the limb rim in the fragment shader was measured and fitted
        // against it (uRimCtr/uRimW/uRimStr were tuned to Hero.png with this
        // behaviour in place). Correcting the order re-lights the whole disc and
        // blows the hero out - verified: limb profile goes 84/100/91/77 to
        // 176/243/244/245 against a Hero.png target that peaks at 176.8.
        // Anything needing a TRUE world position uses vFragW below instead.
        vWorldPos = vWPos;
        vWorldNrm = normalize(mat3(modelMatrix) * normalize(position));
        vWPos = (modelMatrix * vec4(transformed,1.0)).xyz;
        vFragW = vWPos;

        // Analytic normal from neighbouring height taps, computed PER VERTEX.
        // Screen-space dFdx/dFdy are constant across each 2x2 pixel quad, so a
        // per-texel displaced surface shades as visible square blocks. Doing it
        // here and letting it interpolate removes that entirely.
        {
          vec3 n = normalize(position);
          float du = 1.0/2048.0, dv = 1.0/1024.0;
          float hU = textureLod(uHeight, uv + vec2(du,0.0), 0.0).r - 0.5;
          float hV = textureLod(uHeight, uv + vec2(0.0,dv), 0.0).r - 0.5;
          // equirect arc lengths on a unit sphere; longitude compresses as sin(polar)
          float sinPhi = max(sqrt(max(n.x*n.x + n.z*n.z, 0.0)), 0.02);
          float arcU = 6.2831853 * du * sinPhi;
          float arcV = 3.1415927 * dv;
          vec3 rawTu = cross(vec3(0.0,1.0,0.0), n);
          vec3 Tu = length(rawTu) > 1e-5 ? normalize(rawTu) : vec3(1.0,0.0,0.0);
          vec3 Tv = normalize(cross(n, Tu));
          float su = (hU - h) * uDisp / arcU;
          float sv = (hV - h) * uDisp / arcV;
          vec3 dn = normalize(n - Tu*su - Tv*sv);
          vDispNormal = normalize(normalMatrix * dn);   // view space, matching three
        }`);

    sh.fragmentShader = sh.fragmentShader
      .replace('#include <common>', `#include <common>
        uniform float uDetMul; uniform float uDetAmt; uniform float uDetAlb;
        uniform float uDetNear; uniform float uDetFar;
        uniform float uDetail; uniform sampler2D uTile; uniform float uTileRep;
        uniform float uTileAmt; uniform float uRelief; uniform vec2 uTexel; uniform float uKmSpan; uniform float uSgnU; uniform float uSgnV;
        uniform sampler2D uHeight;          // declared in the VERTEX shader too; both need it
        // DEM slopes, computed in normal_fragment_begin and reused by the rim
        float gSU, gSV;
        varying vec2 vMoonUv;
        uniform vec3 uRimCol; uniform float uRimCtr; uniform float uRimW;
        uniform float uRimStr; uniform float uRimTerr; uniform float uRimTail; uniform float uRimTailM; uniform float uRimDbg; uniform float uRimPowIn;
        varying vec3 vWorldPos; varying vec3 vWorldNrm; varying vec3 vFragW;
        varying vec3 vObjPos; varying vec3 vWPos; varying vec3 vDispNormal;
        varying vec2 vTileUv;`)
      // Geometric normal straight off the displaced surface: no 8-bit gradient,
      // so none of the quantisation noise that killed the derived-normal route.
      // NOTE: append after the chunk, never replace it. r169's
      // normal_fragment_begin declares `nonPerturbedNormal` (used downstream for
      // geometry roughness) and `geometryNormal` is declared later - replacing
      // the chunk deletes the first and redefines the second.
      .replace('#include <normal_fragment_begin>', `#include <normal_fragment_begin>
        {
          // One texture sample replaces ~243 hash calls per fragment. The tile is
          // the same crater field, baked periodic; see moon_src/bake_crater_tile.py
          // Real lunar topography drives the shading. NASA LDEM at 2.67 km/px,
          // slopes computed in the sphere's tangent frame with the equirect
          // cos(latitude) compression applied - without it every crater smears
          // toward the poles. The procedural tile is now only a top-up for
          // features below the DEM's 5.3 km resolution floor.
          vec3 gN = normalize(vDispNormal);
          float hC = texture2D(uHeight, vMoonUv).r;
          float hE = texture2D(uHeight, vMoonUv + vec2(uTexel.x, 0.0)).r;
          float hN = texture2D(uHeight, vMoonUv + vec2(0.0, uTexel.y)).r;
          float lat = (0.5 - vMoonUv.y) * 3.14159265;
          float cosLat = max(cos(lat), 0.05);
          float dxKm = 1737.4 * cosLat * 6.2831853 * uTexel.x;
          float dyKm = 1737.4 * 3.14159265 * uTexel.y;
          float su = ((hE - hC) * uKmSpan / dxKm) * uRelief;
          float sv = ((hN - hC) * uKmSpan / dyKm) * uRelief;
          gSU = su; gSV = sv;
          vec3 p  = normalize(vObjPos);
          vec3 t1 = normalize(cross(vec3(0.0,1.0,0.0), p));   // east
          vec3 t2 = normalize(cross(p, t1));                  // north
          vec3 perturbed = normalize(gN - t1*su*uSgnU - t2*sv*uSgnV);
          vec3 tn = texture2D(uTile, vTileUv).xyz * 2.0 - 1.0;
          perturbed = normalize(perturbed + (t1*tn.x + t2*tn.y) * uTileAmt);
          // finer octave, weighted in only as the camera closes on the surface
          float detW = 1.0 - smoothstep(uDetNear, uDetFar, length(cameraPosition - vFragW));
          if (detW > 0.001) {
            vec3 dn = texture2D(uTile, vTileUv * uDetMul).xyz * 2.0 - 1.0;
            perturbed = normalize(perturbed + (t1*dn.x + t2*dn.y) * uTileAmt * uDetAmt * detW);
          }
          normal = perturbed;
          nonPerturbedNormal = gN;
        }`)
      .replace('#include <map_fragment>', `#include <map_fragment>
        {
          // Break up the magnified albedo at close range with the same fine tile.
          // Without it the colour map is a smooth blur of compression blocks no
          // matter how much normal detail sits on top of it.
          float aW = 1.0 - smoothstep(uDetNear, uDetFar, length(cameraPosition - vFragW));
          if (aW > 0.001) {
            vec3 an = texture2D(uTile, vTileUv * uDetMul).xyz * 2.0 - 1.0;
            diffuseColor.rgb *= 1.0 + (an.x + an.y) * uDetAlb * aW;
          }
        }`)
      .replace('#include <emissivemap_fragment>', `#include <emissivemap_fragment>
        {
          // Measured off Hero.png along the surface normal, every 2px:
          //   0px 42.7 | 8px 176.8 (PEAK) | 16px 142.9 | 36px 80.0 | 62px 50.8
          // The band is ASYMMETRIC - it rises steeply from the silhouette and
          // falls away gently inward. A pow(1-N.V, k) tail is maximal AT the
          // silhouette, which is backwards and is what kept my edge at 119.
          vec3 V = normalize(cameraPosition - vWorldPos);
          // Use the CRATER-PERTURBED normal, not the smooth geometric one. With the
          // geometric normal the rim is a flat wash laid over the terrain and hides
          // it; the board's limb shows craters straight through the bright band,
          // because there the brightness IS the terrain catching grazing light.
          // Rebuilt in world space here: the perturbed normal used for shading mixes
          // a view-space vDispNormal with object-space tangents, so it cannot be
          // reused against a world-space view vector.
          vec3 pw  = normalize(vWorldNrm);
          vec3 t1w = normalize(cross(vec3(0.0,1.0,0.0), pw));
          vec3 t2w = normalize(cross(pw, t1w));
          vec3 rimN = normalize(pw - t1w*gSU*uSgnU - t2w*gSV*uSgnV);
          // The band's POSITION comes from the smooth normal, or crater slopes
          // anywhere on the disc satisfy the rim condition and the limb band
          // dissolves into an all-over sparkle. Only its BRIGHTNESS follows the
          // terrain, which is what lets craters read through it.
          float ndv  = clamp(dot(pw, V), 0.0, 1.0);
          float terr = clamp(dot(rimN, V) / max(ndv, 1e-3), 0.0, 2.2);
          // Asymmetric gaussian in N.V. The centre is 0.708, NOT ~0.14: this moon
          // is close enough that the silhouette annulus is compressed, so N.V runs
          // 0.16 -> 0.71 within the first 8 screen pixels. Measured with ?ndv=1.
          // Inward of the peak the board follows a POWER law normalised to N.V=1,
          // not a gaussian: a gaussian wide enough to hold 36px is still lifting
          // 160px. Fitting 0.708/0.758/0.86/0.94/0.996 gives exponent ~1.33 and
          // it reaches exactly zero at the sub-camera point.
          float dd = ndv - uRimCtr;
          float u  = clamp(dd / max(1.0 - uRimCtr, 1e-4), 0.0, 1.0);
          float fall = dd < 0.0
              ? exp(-pow(dd / (uRimW * 1.74), 2.0))    // steep rise from the silhouette
              : pow(1.0 - u, uRimPowIn);
          float rise = 1.0;
          if (uRimDbg > 0.5) {
            // debug: output N.V directly so the screen-depth -> ndv mapping can be measured
            // output ONLY ndv: kill diffuse so lighting cannot inflate the read
            diffuseColor.rgb = vec3(0.0);
            totalEmissiveRadiance = vec3(ndv);
          } else {
            totalEmissiveRadiance += uRimCol * rise * fall * uRimStr * mix(1.0, terr, uRimTerr);
          }
        }`);
    moonMat.userData.shader = sh;
    // ---- keep the rim centred on the limb as the camera moves -----------------
    // N.V at the limb is a function of how far away the camera is, and the entry
    // animation changes that by 30 units. Measured at five distances (?ndv=1, two
    // px inside the limb, median across columns) it runs 0.9451 at d=41 down to
    // 0.7961 at d=71, and is linear in R/d to within 0.0017:
    //     N.V_limb = 0.4268*(R/d) + 0.5928
    // Held at a constant the band detaches from the edge and closes into a drawn
    // ring during the fly-in, because 0.15 of drift is twice the whole width of
    // mobile's N.V range. Desktop keeps its fitted constant - it is locked, and
    // its own drift is hidden by the moon being small in frame.
    if (VIEW.isM && !QP.has('mrimctr')) {
      window.__rimTrack = () => {
        const d = camera.position.length();
        sh.uniforms.uRimCtr.value = 0.4268 * (MOON_R / d) + 0.5928;
      };
      window.__rimTrack();
    }
  };
  if (Q.get('probe') === '1') {
    moonMesh.material = new THREE.MeshBasicMaterial({color:0xffffff});
  } else {
    moonMesh.material = moonMat;
  }
  if (Q.get('probe') === '1') {
    document.getElementById('cx-panels').style.display='none';
    document.getElementById('cx-stage').style.display='none';
    document.getElementById('cx-hud_frame').style.display='none';
    document.getElementById('cx-hud_glyph').style.display='none';
    const sh=document.getElementById('cx-scrollhint'); if(sh) sh.style.display='none';
    document.getElementById('cx-hud').style.display='none';
  }
  moonMesh.scale.setScalar(34);
  // Which lunar LONGITUDE faces the camera at rest.
  // three.js SphereGeometry maps u=0.25 to +Z, and a standard NASA equirect puts
  // longitude 0 (the near side, the face everyone recognises) at u=0.5. So with
  // no rotation the camera sits over longitude 270 and we were showing the far
  // side: uniformly cratered, no maria, unrecognisable as the Moon.
  // The hero turned out NOT to depend on this: it shows a rim-lit crescent edge,
  // not a disc, and reads identically at -90/0/90/180 (mean 25.3-27.9, contrast
  // 41-48). So this is chosen for the LANDING SITE instead, which is the only
  // place terrain actually reads. 135 measured 1.307 relief against 0.275 at -90,
  // because -90 puts the camera over the smooth central maria.
  moonMesh.rotation.y = THREE.MathUtils.degToRad(parseFloat(Q.get('moonlon') || '135'));
  window.__moon = moonMesh;
  moonMesh.position.set(0,0,0);
  scene.add(moonMesh);

  // ---- outward limb glow -----------------------------------------------------
  // The rim above is a per-fragment term ON the sphere, so it stops dead at the
  // silhouette. The board's does not: measured outward from its peak it still
  // reads 125 at 6px and 4 at 10px OUTSIDE the disc. Nothing computed on the
  // moon's own surface can produce that, so this is a slightly larger shell
  // rendered BACK faces only: its rear hemisphere sits behind the moon, the moon
  // occludes the middle via the depth test, and only the annulus survives.
  {
    // The shell's thickness is R*GS in WORLD units, so how wide it reads on screen
    // depends entirely on how big the moon is in frame. Desktop's 0.006 is 0.2
    // units - about 2.7 board px at mobile's scale, a hairline where the board
    // shows a ~15px corona.
    // With the RADIAL falloff below, GS sets how far the glow reaches and uPow
    // how fast it dies. A thick shell with a SLOW falloff is what removes the
    // bubble: measured at the outer boundary, the original fresnel jumped 203
    // per px (a drawn arc), 0.030/pow3 still jumped 61, and 0.060/pow1.2 jumps 5.
    // The board's own edge jumps 52, so this errs softer than the board.
    const GS = vnum('mglowsize', '0.035', 'glowsize', '0.006');
    const glow = new THREE.Mesh(
      new THREE.SphereGeometry(MOON_R * (1.0 + GS), 96, 64),
      new THREE.ShaderMaterial({
        uniforms: {
          uCol: { value: new THREE.Color(Q.get('glow_col') || '#c9a0ff') },
          uStr: { value: vnum('mglow', '1.2', 'glow', '0.20') },
          uPow: { value: vnum('mglowpow', '1.2', 'glowpow', '5.0') },
          // 0 = the original fresnel falloff, 1 = radial. Desktop stays on the
          // fresnel so its locked look is bit-identical; mobile uses radial.
          uMode: { value: VIEW.isM ? parseFloat(Q.get('mglowmode') ?? '1') : 0.0 },
          uAngM: { value: 0 },     // angular radius of the moon, per frame
          uAngS: { value: 0 },     // angular radius of this shell
        },
        vertexShader: `varying vec3 vGN; varying vec3 vGW;
          void main(){
            vGW = (modelMatrix * vec4(position,1.0)).xyz;
            vGN = normalize(mat3(modelMatrix) * normal);
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
          }`,
        fragmentShader: `uniform vec3 uCol; uniform float uStr; uniform float uPow;
          uniform float uMode; uniform float uAngM; uniform float uAngS;
          varying vec3 vGN; varying vec3 vGW;
          void main(){
            vec3 V = normalize(cameraPosition - vGW);
            // ORIGINAL: fresnel on the shell. It peaks at 1.0 exactly where the
            // shell's own silhouette is, so the glow is brightest at the mesh
            // edge and then stops dead - which reads as a hard bright arc, a
            // bubble of atmosphere drawn around the moon.
            float fFres = pow(1.0 - abs(dot(normalize(vGN), V)), uPow);
            // RADIAL: shape by the fragment's ANGLE off the camera->centre axis
            // instead. 0 at the moon's own limb, 1 at the shell's silhouette, so
            // the glow is brightest where it meets the moon and reaches exactly
            // zero where the geometry ends. No edge to see.
            vec3 toP = normalize(vGW - cameraPosition);
            vec3 toC = normalize(-cameraPosition);
            float ang = acos(clamp(dot(toP, toC), -1.0, 1.0));
            float t   = clamp((ang - uAngM) / max(uAngS - uAngM, 1e-5), 0.0, 1.0);
            float fRad = pow(1.0 - t, uPow);
            float f = mix(fFres, fRad, uMode);
            gl_FragColor = vec4(uCol * uStr * f, f);
          }`,
        transparent: true, blending: THREE.AdditiveBlending,
        side: THREE.BackSide, depthWrite: false,
      }));
    // The two angular radii depend on where the camera is, so they are refreshed
    // every frame rather than baked. Moon centre is the world origin.
    window.__glowAngles = () => {
      const d = camera.position.length();
      glow.material.uniforms.uAngM.value = Math.asin(Math.min(1, MOON_R / d));
      glow.material.uniforms.uAngS.value = Math.asin(Math.min(1, MOON_R * (1.0 + GS) / d));
    };
    window.__glowAngles();
    glow.renderOrder = 1;          // after the moon, so the depth test can clip it
    glow.visible = Q.get('glow') !== '0';
    scene.add(glow); window.__glow = glow;
  }

  // ---------------- CRYSTALS ----------------
  const rocks = [];
  const wanted = ['A','B','C','D','E','F'].map(s=>'Cosmic_Crystal_'+s);
  for (const n of wanted){
    const o = crystalsGltf.scene.getObjectByName(n);
    if(!o){ say(`FAIL: missing node ${n}`); continue; }
    rocks.push(o);
    // COLOR_0 carries baked per-vertex THICKNESS (3d/bake_crystal_thickness.py).
    // Renamed off `color` so three.js does not see USE_COLOR and multiply it into
    // diffuseColor - it is a path length, not a tint.
    const g = o.geometry;
    if (g && g.attributes.color && !g.attributes.aThick) {
      g.setAttribute('aThick', g.attributes.color);
      g.deleteAttribute('color');
    }
  }
  const withThk = rocks.filter(r => r.geometry && r.geometry.attributes.aThick).length;
  say(`crystals found: ${rocks.length}/6  (thickness attr on ${withThk})`);

  // Beer-Lambert glass. KHR_materials_volume does not survive the Blender export,
  // so attenuation is set here explicitly. attenuationDistance is the distance
  // over which light falls to attenuationColor - the three.js equivalent of
  // Blender's volume density (roughly 1/density, in world units).
  const D = parseFloat(Q.get('dens') || '3.0');
  // Per-unit-thickness transmittance. three.js computes
  //   transmitted = attenuationColor ^ (thickness / attenuationDistance)
  // and with attenuationDistance = 1/D the D cancels exactly, leaving
  // base^thickness. THICKNESS is the real depth control; dens only bites if
  // ?atten= is given separately.
  // Blue must stay BELOW 1.0. At exactly 1.0 it is never absorbed at any
  // thickness (1^n = 1), so a rock sitting in front of anything bright - the
  // lit moon limb - transmits full blue and clips to 255 while R and G are
  // annihilated. That was the electric-blue rock 2.
  const ABASE = [
    parseFloat(Q.get('ar') || '0.825'),
    parseFloat(Q.get('ag') || '0.747'),
    parseFloat(Q.get('ab') || '0.881'),
  ];
  const cMat = new THREE.MeshPhysicalMaterial({
    color: 0xffffff,
    metalness: 0.0,
    roughness: parseFloat(Q.get('crough') || '0.10'),
    transmission: parseFloat(Q.get('trans') || '0.72'),
    ior: parseFloat(Q.get('cior') || '1.62'),
    thickness: parseFloat(Q.get('thick') || '12.0'),
    attenuationColor: new THREE.Color(
      Math.pow(ABASE[0],1/D), Math.pow(ABASE[1],1/D), Math.pow(ABASE[2],1/D)),
    attenuationDistance: parseFloat(Q.get('atten') || String(1.0/D)),
    transparent: false,
    side: THREE.FrontSide,
  });

  const ROCK_RISE  = parseFloat(Q.get('rise')  || '70');   // px up from the SVG position
  const ROCK_SCALE = parseFloat(Q.get('rscale')|| '1.55');  // multiplier on the SVG size
  // Every placed rock carries the scroll position `t` of the panel it belongs to.
  // boardToWorld() unprojects through whatever camera is current, so a rock has to
  // be anchored through the camera of ITS OWN panel or it lands somewhere behind
  // the viewer. bx/by are that panel's board coordinates.
  const HERO_ROCKS = [
    // panel 1 - hero, Figma frame 1
    { mesh: (Q.get('r1') || 'Cosmic_Crystal_A'), t:PANEL_T[0], pi:0, bx: 53+101/2,  by: 294+105/2 - ROCK_RISE, px:101*ROCK_SCALE, dist:13, rot:0 },
    { mesh: (Q.get('rock')==='det' ? 'Cosmic_Crystal_A' : (Q.get('r2') || 'Cosmic_Crystal_D')),
      t:PANEL_T[0], pi:0, bx:1269+98/2,  by: 574+101/2 - ROCK_RISE, px: 98*ROCK_SCALE, dist:13, rot:Math.PI/4,
      clone: Q.get('rock')==='det' },
    // panel 3 - watch reveal, Figma frame 3 (board y 1640-2589) mapped through the
    // 818/949 = 0.862 fit that the DOM layer uses, so rock and type stay registered
    { mesh:'Cosmic_Crystal_C', t:PANEL_T[2], pi:2, bx: 166, by: 558, px:108*ROCK_SCALE, dist:13, rot:0 },       // 1.44x the board: the chunky C/F meshes read smaller
    { mesh:'Cosmic_Crystal_F', t:PANEL_T[2], pi:2, bx:1311, by: 478, px: 95*ROCK_SCALE, dist:13, rot:Math.PI/4 },
    // C and F stay parked: the form is a modal over the watch panel, so it borrows
    // that panel's pair instead of placing its own.
  ];
  // Mobile carries two rocks in the hero, measured off Mobile.svg: left at
  // x 14.8..63.8 / y 134.5..187.2, right at x 348.5..387.5 / y 187.5..237.
  // Sections 2 and 3 are still to come, so their rocks stay on the desktop spec
  // and are simply not visible until those panels are built.
  if (VIEW.isM) {
    // px is a REQUEST measured against the mesh's bounding sphere, and the meshes
    // are irregular and rotated, so the silhouette that lands is bigger than the
    // number asked for. Calibrated: asking 82 rendered 104 (x1.27) and asking 76
    // rendered 92 (x1.19), so these are the board's 49 and 39 divided back out.
    // ROCK_SCALE is deliberately NOT applied - it is a desktop taste multiplier.
    // ROCK_RISE likewise: on a 402x864 board a 70px lift throws them off screen.
    HERO_ROCKS[0].bx = 39;  HERO_ROCKS[0].by = 161; HERO_ROCKS[0].px = 39;
    HERO_ROCKS[1].bx = 368; HERO_ROCKS[1].by = 212; HERO_ROCKS[1].px = 33;
    // Section 3: board has one mid-LEFT at x 0..46.8 / y 538.5..607.2 and one
    // top-RIGHT at x 364.8..401.8 / y 24.5..77.2. C is the left one on desktop
    // too, so the pairing holds. Same /1.2 calibration as the hero pair.
    HERO_ROCKS[2].bx = 23;  HERO_ROCKS[2].by = 573; HERO_ROCKS[2].px = 34;
    HERO_ROCKS[3].bx = 383; HERO_ROCKS[3].by = 51;  HERO_ROCKS[3].px = 24;
  }
  window.__rocksSpec = HERO_ROCKS;
  const byName = n => rocks.find(r => r.name === n);
  // give each placed rock its own layer, matched to its own light
  function assignRockLayer(obj, idx){ /* layers no longer used for lighting */ }
  // a single exported mesh has to serve both hero slots: clone it for the second
  for (const h of HERO_ROCKS) {
    if (!h.clone) continue;
    const src = byName(h.mesh);
    if (src && !byName(h.mesh + '_clone')) {
      const c = src.clone(); c.name = h.mesh + '_clone'; c.visible = true;
      scene.add(c); rocks.push(c); h.mesh = c.name;
    }
  }
  // Each rock's light sits on the camera->rock line, pushed out BEHIND the rock,
  // aimed back at it. So it shines straight through that rock toward the viewer
  // and, being on that rock's layer alone, touches nothing else.
  const BEHIND = parseFloat(Q.get('behind') || '3.1');
  const FRONT  = parseFloat(Q.get('front')  || '3.1');
  // position each VIRTUAL light behind its own rock unless given explicit coords
  function placeRockLight(obj, i){
    const V = VLIGHTS[i];
    if (!V || !obj || V.manual) return;
    const axis = obj.position.clone().sub(camera.position).normalize();
    V.pos.copy(obj.position).add(axis.clone().multiplyScalar(BEHIND));
    V.fpos.copy(obj.position).sub(axis.clone().multiplyScalar(FRONT));
    // remember which camera this was aimed from, so the debug readout can check
    // the front light against ITS OWN panel camera rather than whatever camera
    // happens to be live (in ?free=1 that is the orbit camera, which reported
    // a correctly-placed light as WRONG SIDE).
    V.camAt = camera.position.clone();
  }
  // Each panel owns its own crystals. They are real objects in world space, so
  // without this the watch pair stays in frame all the way back through the
  // numerology section, which has none on the board.
  // Driven off the panels' own fade rather than a second scroll window: the fade
  // is not symmetric around a panel's pin point (0.35 in, 0.35 out of a 1.0 slot),
  // so any window tuned to match it drifted at one end or the other.
  // Hard toggle, not a fade: these materials are transmissive, and turning on
  // transparent:true moves them into the transparent pass and reorders them
  // against the moon.
  window.__panelOp = [1, 0, 0];
  window.__rockVis = () => {
    if (Q.get('probe') === '1') return;
    const showAll = Q.get('free') === '1';          // orbit mode inspects everything
    for (const h of HERO_ROCKS){
      const o = byName(h.mesh);
      if (o) o.visible = showAll || (window.__panelOp[h.pi] || 0) > 0.05;
    }
  };
  window.__anchorRocks = () => {
    // boardToWorld() unprojects through the CURRENT camera. In orbit mode the
    // camera is somewhere else entirely, so anchor through the HERO camera every
    // time and restore afterwards - that gives the same world positions in both
    // modes, instead of freezing whatever the orbit camera happened to be.
    const savedPos = camera.position.clone();
    const savedQuat = camera.quaternion.clone();
    const savedUp = camera.up.clone();
    // zero the entry offset while anchoring, or the rocks pin themselves to the
    // camera's fly-in altitude and get stranded once it settles
    const savedT = window.__scrollT || 0;
    const savedEntry = window.__entryMoon || 0;
    window.__entryMoon = 0;
    HERO_ROCKS.forEach((h, i) => {
      const o = byName(h.mesh);
      if (!o) return;
      if (!o.userData.vlitMat) { o.material = makeRockMaterial(i); o.userData.vlitMat = true; }
    });
    // Anchor each rock through the camera of its OWN panel. Doing them all through
    // the hero camera buried the later panels' rocks inside the moon or stranded
    // them behind the viewer, because by then the rig has pitched up to 180deg.
    for (const h of HERO_ROCKS){
      const o = byName(h.mesh);
      if(!o) continue;
      applyScroll(h.t || 0);              // SETTLED rig for this rock's panel
      camera.updateMatrixWorld(true);
      o.position.copy(boardToWorld(h.bx, h.by, h.dist));
      // scale so the rock covers h.px board pixels at this distance
      placeRockLight(o, HERO_ROCKS.indexOf(h));
      const wantPx = h.px * boardScale();
      const vFOV = THREE.MathUtils.degToRad(camera.fov);
      const worldPerPx = (2*Math.tan(vFOV/2)*h.dist) / HH();
      // Measure the mesh instead of assuming "~2 units across": the six chips
      // differ enough that a shared constant made the later panels' rocks land
      // about 1.4x oversize, so h.px stopped meaning board pixels.
      if (!o.geometry.boundingBox) o.geometry.computeBoundingBox();
      const bb = o.geometry.boundingBox;
      const span = Math.max(bb.max.x-bb.min.x, bb.max.y-bb.min.y) || 2.0;
      o.scale.setScalar((wantPx * worldPerPx) / span);
    }
    window.__entryMoon = savedEntry;
    // restore whatever camera the caller had (orbit, scrolled, etc.)
    camera.position.copy(savedPos);
    camera.quaternion.copy(savedQuat);
    camera.up.copy(savedUp);
    camera.updateMatrixWorld(true);
    // applyScroll() was driven to each rock's own panel above, so both the
    // visibility window and __scrollT ended up on whichever rock was anchored
    // last. onScroll() corrects that immediately in scroll mode, but nothing
    // does in ?free=1, which left the debug readout reporting t=1 at rest.
    window.__scrollT = savedT;
    window.__rockVis();
  };
  // one material CLONE per rock, each with its own virtual-light uniforms
  function makeRockMaterial(idx){
    const m = cMat.clone();
    m.userData.u = {
      uVLpos: { value: VLIGHTS[idx].pos },
      uVLcol: { value: VLIGHTS[idx].col },
      uVLint: { value: VLIGHTS[idx].int },
      uVFpos: { value: VLIGHTS[idx].fpos },
      uVFcol: { value: VLIGHTS[idx].fcol },
      uVFint: { value: VLIGHTS[idx].fint },
      uThkPow:  { value: parseFloat(Q.get('thkpow')  || '1.0') },  // shapes the baked thickness curve
      uRghThin: { value: parseFloat(Q.get('rghthin') || '0.62') }, // roughness where the glass is thinnest
      uRghKnee: { value: parseFloat(Q.get('rghknee') || '0.30') }, // thickness at which it is fully clear
      uStrAmt:  { value: parseFloat(Q.get('streak')  || '25.0') }, // internal ray strength
      uStrFreq: { value: parseFloat(Q.get('strfreq') || '5.5') },
      uStrDep:  { value: parseFloat(Q.get('strdep')  || '2.2') },  // how far along the refracted ray to sample
      // Sparsity. At 2.2 the noise is a smooth wash: it lifted the crystal's floor
      // as fast as its peaks (p5 21.7 -> 50.7 while p99 54 -> 165, range stuck at
      // ~3x against the board's 443x). Rays need most of the volume DARK.
      uStrPow:  { value: parseFloat(Q.get('strpow')  || '7.0') },
      uStrMod:  { value: parseFloat(Q.get('strmod')  || '0.99') },  // how hard the structure gates transmission
      uFacet:   { value: parseFloat(Q.get('facet')   || '0.35') }, // fracture striations on the facets
      uFacetF:  { value: parseFloat(Q.get('facetf')  || '22.0') },
      uVLamb: { value: parseFloat(Q.get('cl_amb') || '0.0') },
      uEnvKeep: { value: parseFloat(Q.get('cenv') || '1.4') },
    };
    m.onBeforeCompile = (sh) => {
      setTimeout(()=>{ window.__rockFrag = sh.fragmentShader; window.__rockVert = sh.vertexShader; },0);
      Object.assign(sh.uniforms, m.userData.u);
      sh.vertexShader = sh.vertexShader
        .replace('#include <common>', `#include <common>
          varying vec3 vRockW; varying vec3 vRockN; varying vec3 vRockO; varying float vThk;
          attribute vec4 aThick;`)
        .replace('#include <begin_vertex>', `#include <begin_vertex>
          vRockW = (modelMatrix * vec4(position,1.0)).xyz;
          vRockN = normalize(mat3(modelMatrix) * normal);
          vRockO = position;
          vThk   = aThick.r;`);
      sh.fragmentShader = sh.fragmentShader
        .replace('#include <common>', `#include <common>
          uniform vec3 uVLpos; uniform vec3 uVLcol; uniform float uVLint; uniform float uVLamb;
          uniform vec3 uVFpos; uniform vec3 uVFcol; uniform float uVFint;
          uniform float uEnvKeep;
          uniform float uThkPow, uRghThin, uRghKnee, uStrAmt, uStrFreq, uStrDep, uStrPow, uStrMod, uFacet, uFacetF;
          varying vec3 vRockW; varying vec3 vRockN; varying vec3 vRockO; varying float vThk;
          // cheap value noise; no texture, and the meshes carry no UVs anyway
          float rhash(vec3 p){ return fract(sin(dot(p, vec3(127.1,311.7,74.7))) * 43758.5453); }
          float rnoise(vec3 p){
            vec3 i = floor(p), f = fract(p);
            f = f*f*(3.0-2.0*f);
            float n000=rhash(i), n100=rhash(i+vec3(1,0,0)), n010=rhash(i+vec3(0,1,0)), n110=rhash(i+vec3(1,1,0));
            float n001=rhash(i+vec3(0,0,1)), n101=rhash(i+vec3(1,0,1)), n011=rhash(i+vec3(0,1,1)), n111=rhash(i+vec3(1,1,1));
            return mix(mix(mix(n000,n100,f.x), mix(n010,n110,f.x), f.y),
                       mix(mix(n001,n101,f.x), mix(n011,n111,f.x), f.y), f.z);
          }`)
        // Discard ALL scene lighting on this rock. Layers cannot do this in the
        // forward renderer, so zero the accumulators directly: the moon's sun,
        // backlight and hemisphere then contribute nothing here, and the rock is
        // lit purely by its own virtual light. ?scenelit=1 puts them back.
        // Per-fragment thickness. three.js only offers a scalar thickness or a
        // thicknessMap, and the meshes have no UVs - so the baked vertex value is
        // multiplied in here. This is what turns one flat absorption value into
        // the splotches: path length now varies from a thin edge to the body.
        .replace('#include <transmission_fragment>', `#include <transmission_fragment>
        #ifdef USE_TRANSMISSION
          material.thickness *= pow(clamp(vThk, 0.0, 1.0), uThkPow);
        #endif`)
        // Thin glass frosts, thick glass stays clear. Same variable, so the two
        // read as one material rather than two effects fighting.
        .replace('#include <roughnessmap_fragment>', `#include <roughnessmap_fragment>
        roughnessFactor = mix(uRghThin, roughnessFactor,
                              smoothstep(0.0, max(uRghKnee, 1e-3), vThk));`)
        .replace('#include <lights_fragment_end>', `#include <lights_fragment_end>
        #ifndef ROCK_KEEP_SCENE_LIGHT
          // Kill only the DIRECT lights - the moon's sun and backlight - so their
          // highlight stops landing on the rock. Keep indirectSpecular: that is the
          // environment map, and it is what makes the facets read as polished glass
          // rather than a rough lump. Zeroing it was what roughened the surface.
          reflectedLight.directDiffuse    = vec3(0.0);
          reflectedLight.directSpecular   = vec3(0.0);
          reflectedLight.indirectDiffuse *= uEnvKeep;
          reflectedLight.indirectSpecular *= uEnvKeep;
        #endif`)
        .replace('#include <emissivemap_fragment>', `#include <emissivemap_fragment>
        {
          // Virtual light: belongs to THIS rock alone. Not a scene light, so it
          // cannot reach the moon or the other rocks.
          vec3 N = normalize(vRockN);
          vec3 L = normalize(uVLpos - vRockW);
          vec3 V = normalize(cameraPosition - vRockW);
          float diff = max(dot(N, L), 0.0);
          // back-lit transmission: light arriving from BEHIND the surface
          float back = max(dot(-N, L), 0.0);
          float wrap = pow(back, 1.6);
          // specular glint on the facets
          vec3  H = normalize(L + V);
          float spec = pow(max(dot(N, H), 0.0), 48.0);
          // rim where the surface turns away from the viewer
          float rim = pow(1.0 - max(dot(N, V), 0.0), 3.0);
          // The internal structure MODULATES the transmitted light rather than being
          // added on top of it. Adding left a flat wash underneath - the crystal's
          // floor and its peaks rose together and the range stayed at ~3x against
          // the board's 443x. Multiplying lets the dark channels actually go dark.
          vec3  rd0 = refract(-V, N, 1.0/1.62);
          float q1 = rnoise(vRockO * uStrFreq + rd0 * uStrDep);
          float q2 = rnoise(vRockO * (uStrFreq * 2.7) - rd0 * (uStrDep * 1.6));
          float chan = pow(clamp(q1 * 0.65 + q2 * 0.35, 0.0, 1.0), uStrPow);
          float wmod = mix(1.0 - uStrMod, 1.0 + uStrMod * 2.0, chan);
          totalEmissiveRadiance += uVLcol * uVLint *
            (diff * 0.06 + wrap * wmod + spec * 0.22 + rim * 0.14) + uVLcol * uVLamb;

          // Front fill. Diffuse-dominant and no wrap term: this one is not shining
          // THROUGH the rock, it is picking out the facets pointed at the viewer,
          // so a broader specular (20 vs 48) reads as a soft sheen rather than a
          // second hard glint competing with the back light's.
          vec3  Lf = normalize(uVFpos - vRockW);
          float fdiff = max(dot(N, Lf), 0.0);
          vec3  Hf = normalize(Lf + V);
          float fspec = pow(max(dot(N, Hf), 0.0), 20.0);
          float frim  = pow(1.0 - max(dot(N, V), 0.0), 2.0);
          totalEmissiveRadiance += uVFcol * uVFint *
            (fdiff * 0.85 + fspec * 0.35 + frim * 0.10);

          // Internal rays. Sampled along the REFRACTED direction in object space,
          // so the pattern slides as the rock turns - that is what reads as the
          // underwater shimmer rather than a texture painted on the surface.
          // Weighted by thickness: thin glass has no depth for rays to form in.
          // a small additive component on top, weighted by thickness, for the
          // brightest caustic cores only
          float streak = chan;
          totalEmissiveRadiance += uVLcol * uVLint * uStrAmt * streak * wrap * vThk * 6.0;

          // Fracture striations. The chips are 2200 flat-shaded tris with no
          // normal map; without this every facet is a single flat tone.
          float fn = rnoise(vRockO * uFacetF);
          totalEmissiveRadiance += uVFcol * uVFint * uFacet * fn * (1.0 - vThk);
          #ifdef ROCK_THK_DEBUG
            diffuseColor.rgb = vec3(0.0);
            totalEmissiveRadiance = vec3(vThk);
          #endif
          #ifdef ROCK_STREAK_DEBUG
            diffuseColor.rgb = vec3(0.0);
            totalEmissiveRadiance = vec3(streak, wrap, vThk);
          #endif
        }`);
    };
    m.defines = Object.assign({}, m.defines,
      Q.get('scenelit')==='1' ? {ROCK_KEEP_SCENE_LIGHT:''} : {},
      Q.get('thkdbg')==='1' ? {ROCK_THK_DEBUG:''} : {},
      Q.get('stdbg')==='1' ? {ROCK_STREAK_DEBUG:''} : {});
    m.needsUpdate = true;
    return m;
  }
  rocks.forEach((o,i)=>{
    o.material = cMat;
    o.visible = false;   // __rockVis owns this from here; see below
    o.scale.setScalar(1.7);
    o.userData.spin = new THREE.Vector3(
      (Math.random()-0.5)*0.05, (Math.random()-0.5)*0.05, (Math.random()-0.5)*0.05
    );
    scene.add(o);
  });
  window.__anchorRocks();

  // ---------------- 5:55:55 as a 3D plane ----------------
  // In the board the moon's limb passes IN FRONT of the digits. DOM can't sit
  // between two things in one canvas, so the clock renders into a canvas texture
  // on a plane placed behind the moon's near surface. Depth sorting does the rest.
  // Measured off each board's own export. Mobile's clock is nearly full bleed
  // (292 of 402) and much shorter, but its cap/width ratio is 0.224 against
  // desktop's 0.230 - the same typeface at a different size, so all the canvas
  // and gradient code below carries over untouched.
  const CLOCK = VIEW.isM
    ? { x0: 55.5, x1: 347.8, capTop: 305.8, capBot: 370.0, dist: 52 }
    : { x0: 285,  x1: 1160,  capTop: 248,   capBot: 449,   dist: 52 };
  function makeClockTexture(){
    const S = 4;                                   // supersample for crisp edges
    const cap0 = CLOCK.capBot - CLOCK.capTop;
    const PAD = Math.round(cap0*0.06);          // digit overshoot
    const boxW = CLOCK.x1 - CLOCK.x0;           // 875px the board's clock spans
    const PADX = 8;                             // antialias margin, symmetric so the centre stays put
    const w = boxW + PADX*2, h = cap0 + PAD*2;
    const cv = document.createElement('canvas');
    cv.width = w*S; cv.height = h*S;
    const x = cv.getContext('2d');
    x.scale(S,S);
    const cap = cap0;                              // 201px measured off the board
    const FONT = px => `700 ${px}px 'Helvetica Neue', Helvetica, Arial, sans-serif`;
    x.textAlign = 'center'; x.textBaseline = 'alphabetic';

    // Solve the size from the face's MEASURED cap height, not a nominal 0.717 em
    // ratio. That constant rendered a cap of 197 where the board's is 201 - 2%
    // small, which showed up as our bowl overshoot stopping at board row 447
    // where the board's runs to 454. Cap height is linear in font size, so one
    // correction pass lands it exactly; measuring beats assuming a metric that
    // depends on which of the fallback faces actually resolved.
    let fontPx = cap / 0.717;                      // first guess only
    x.font = FONT(fontPx);
    fontPx *= cap / x.measureText('5:55:55').actualBoundingBoxAscent;
    x.font = FONT(fontPx);

    // At this cap height Helvetica Bold sets '5:55:55' 925.1px wide against the
    // 875px the board's own clock occupies between x0 and x1 - so centred in a
    // box-width canvas it lost ~25px of ink off EACH end. The board's face is
    // simply narrower; squeeze horizontally to match it rather than drop the font
    // size, which would break the measured 201px cap height the gradient is fitted to.
    const m = x.measureText('5:55:55');
    const inkW  = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
    const sx    = boxW / inkW;
    // textAlign:'center' anchors on the ADVANCE width; centre on the ink instead,
    // or the trailing side bearing walks the glyphs off-centre in the box.
    const inkMid = (m.actualBoundingBoxRight - m.actualBoundingBoxLeft) / 2;

    // chrome ramp measured from Hero.png: linear F0->4D, then a hard bright band
    x.save();
    x.translate(w/2, PAD + cap);
    x.scale(sx, 1);
    x.translate(-inkMid, 0);
    // Gradient must be built in the SAME space the text is filled in. Creating it
    // before translate() offset the whole ramp below the glyphs and they came out flat.
    //
    // A STRAIGHT ramp, 240 at the cap top to 40 at the baseline. Re-measured off
    // Hero.png by taking the MODE of each row across the clock box: the glyph is a
    // flat fill, so its mode is the gradient value at that row whatever crosses in
    // front. Fitting a line to all 41 samples gives 240.1 - 200.3t with an rms
    // residual of 0.20/255 - there is no curve in it and no reflection band.
    //
    // The previous nine-stop ramp, with a bright band near 0.85 plateauing to the
    // baseline, was an artefact of my own sampling: that pass averaged only pixels
    // above a brightness threshold, which near the baseline excludes the dark
    // glyph itself and leaves the moon's lit limb passing behind it. It put the
    // moon INTO the type, as a white strip below the dark end.
    const g = x.createLinearGradient(0, -cap, 0, 0);
    g.addColorStop(0.0, '#F0F0F0');   // 240 at the cap top
    g.addColorStop(1.0, '#282828');   //  40 at the baseline
    x.fillStyle = g;
    // fillText anchors on the BASELINE, and this face's real cap ascent at this
    // size is 197 against the 201 the font size was solved for, so drawing at y=0
    // left the glyph box sitting 4px low: board row 248, the top of the cap, had
    // 2 ink pixels where the board has 482. Anchor on the measured ascent instead.
    // The gradient is NOT moved with it - it stays keyed to the board's 248..449
    // box, so every row keeps the value it already matched exactly.
    x.fillText('5:55:55', 0, m.actualBoundingBoxAscent - cap);
    x.restore();
    const t = new THREE.CanvasTexture(cv);
    t.colorSpace = THREE.SRGBColorSpace;
    t.anisotropy = renderer.capabilities.getMaxAnisotropy();
    return { tex:t, w, h };
  }
  const clockTex = makeClockTexture();
  // three.js renders the transparent pass AFTER all opaque objects, so
  // renderOrder=-1 could never put this behind the moon. Keep it transparent for
  // clean text edges, but let it DEPTH TEST against the moon (which is opaque and
  // therefore already drawn, with depth written) and skip depthWrite itself.
  const clockMat = new THREE.MeshBasicMaterial({
    map: clockTex.tex, transparent:true, depthTest:true, depthWrite:false,
    toneMapped:false });
  // ---- the dissolve ----
  // A soft alpha edge that sweeps DOWN the glyphs as they rise, so the type
  // materialises out of the limb rather than sliding up as a finished block.
  // It is deliberately not a whole-object fade: uProg is the same eased rise
  // progress, so the two are locked and the softness lives only at the leading
  // edge. Band is in UV, i.e. a fraction of the plane's height.
  const CDIS = { uProg: { value: 0 }, uBand: { value: parseFloat(Q.get('cband') || '0.45') } };
  clockMat.onBeforeCompile = (sh) => {
    sh.uniforms.uProg = CDIS.uProg;
    sh.uniforms.uBand = CDIS.uBand;
    // Carry our own varying rather than relying on vMapUv/vUv, whose name has
    // moved between three.js versions and is only defined when a map is present.
    sh.vertexShader = sh.vertexShader
      .replace('#include <common>', '#include <common>\nvarying float vClockV;')
      .replace('#include <begin_vertex>', '#include <begin_vertex>\nvClockV = uv.y;');
    sh.fragmentShader = sh.fragmentShader
      .replace('#include <common>',
        '#include <common>\nvarying float vClockV;\nuniform float uProg;\nuniform float uBand;')
      // after map_fragment so diffuseColor already carries the texture's alpha
      .replace('#include <map_fragment>', `#include <map_fragment>
        // edge travels from just above the plane to just below it, so at uProg=1
        // the smoothstep is fully satisfied everywhere and nothing is left soft
        float ed = mix(1.0 + uBand, -uBand, uProg);
        diffuseColor.a *= smoothstep(ed - uBand, ed, vClockV);`);
  };
  // The clock is a 3D mesh so the moon can occlude it, which means the DOM
  // cross-fade in __panelFade cannot reach it. Without this it stays on screen
  // over sections 2 and 3 - and on a reload anywhere past the hero the entry
  // animation ramps it to full opacity regardless of scroll position.
  window.__clockEntry = 0;
  window.__applyClockOpacity = () => {
    const panel = (window.__panelOp && window.__panelOp[0] !== undefined)
                  ? window.__panelOp[0] : 1;
    clockMesh.material.opacity = (window.__clockEntry || 0) * panel;
  };
  const applyClockOpacity = () => window.__applyClockOpacity();
  const clockMesh = new THREE.Mesh(new THREE.PlaneGeometry(1,1), clockMat);
  clockMesh.renderOrder = 1;
  clockMesh.visible = Q.get('probe')!=='1' && Q.get('noclock')!=='1';
  scene.add(clockMesh);

  window.__placeClock = () => {
    const cx = (CLOCK.x0 + CLOCK.x1)/2;
    // __clockRise pushes the clock DOWN the board during the entry so the moon's
    // limb hides it, then eases to 0. Board pixels, not world units, so the rise
    // reads the same at every viewport size.
    const cy = (CLOCK.capTop + CLOCK.capBot)/2 + (window.__clockRise || 0);
    clockMesh.position.copy(boardToWorld(cx, cy, CLOCK.dist));
    const sc = boardScale();
    const vFOV = THREE.MathUtils.degToRad(camera.fov);
    const worldPerPx = (2*Math.tan(vFOV/2)*CLOCK.dist) / HH();
    clockMesh.scale.set(clockTex.w*sc*worldPerPx, clockTex.h*sc*worldPerPx, 1);
    clockMesh.quaternion.copy(camera.quaternion);    // always face the camera
  };

  // ---------------- starfield: generated, no texture ----------------
  // Mobile needs FEWER, smaller, dimmer stars, not the same field on a small
  // screen. Its vertical fov is 110deg against desktop's ~42, so a far larger
  // slice of the sphere is on screen at once, and that lands on a third of the
  // area - the same 2600 read as a dense white grid where the board has a sparse
  // scatter. Counted off the board's hero: roughly 50 visible, not 200-plus.
  const N = VIEW.isM ? parseInt(Q.get('mstars') || '900', 10) : 2600;
  const STAR_PX  = VIEW.isM ? parseFloat(Q.get('mstarpx')  || '1.5') : 2.4;
  const STAR_DIM = VIEW.isM ? parseFloat(Q.get('mstardim') || '0.62') : 1.0;
  const sp = new Float32Array(N*3), sc = new Float32Array(N*3);
  for(let i=0;i<N;i++){
    const r = 900 + Math.random()*900;
    const th = Math.random()*Math.PI*2, ph = Math.acos(2*Math.random()-1);
    sp[i*3]   = r*Math.sin(ph)*Math.cos(th);
    sp[i*3+1] = r*Math.sin(ph)*Math.sin(th);
    sp[i*3+2] = r*Math.cos(ph);
    const b = (0.35 + Math.random()*0.65) * STAR_DIM;
    sc[i*3]=b; sc[i*3+1]=b*(0.88+Math.random()*0.12); sc[i*3+2]=b;
  }
  const sg = new THREE.BufferGeometry();
  sg.setAttribute('position', new THREE.BufferAttribute(sp,3));
  sg.setAttribute('color', new THREE.BufferAttribute(sc,3));
  const starPts = new THREE.Points(sg, new THREE.PointsMaterial({size:STAR_PX, sizeAttenuation:false, vertexColors:true}));
  starPts.visible = Q.get('probe')!=='1';
  scene.add(starPts);

  // ---------------- loop ----------------
  let frames = 0, fpsT = performance.now(), fps = 0;
  // Moon rotation: constant angular velocity, no easing (vacuum).
  // Per SECOND, not per frame - it used to be 0.00022 rad/frame, which is both
  // frame-rate dependent and 13x too fast. Surface speed is omega * 34, and the
  // surface section sits 2.6 units up where only ~2.0 units of ground are in
  // frame, so the old rate dragged the whole visible surface past in 4 seconds.
  // 0.0010 rad/s crosses that frame in about a minute.
  const MOON_SPIN = parseFloat(Q.get('spin') || '0.0010');
  const ROCK_SPIN = parseFloat(Q.get('rspin') || '1.2');
  let lastT = performance.now();
  renderer.setAnimationLoop(()=>{
    const nowT = performance.now();
    const dt = Math.min((nowT - lastT) / 1000, 0.1);   // cap so a stalled tab cannot jump
    lastT = nowT;
    if (window.__moon) window.__moon.rotation.y += MOON_SPIN * dt;
    for(const o of rocks){
      o.rotation.x += o.userData.spin.x * ROCK_SPIN * dt;
      o.rotation.y += o.userData.spin.y * ROCK_SPIN * dt;
      o.rotation.z += o.userData.spin.z * ROCK_SPIN * dt;
    }
    if (window.__entryTick) {
      if (!window.__entryTick(performance.now())) window.__entryTick = null;
      // Must go through the SAME scroll->rig mapping the scroll handler uses.
      // This used to compute scrollY/(scrollHeight-innerHeight) itself, which is
      // linear: reloading on the numerology section drove the rig to t=0.5 instead
      // of 0.30, i.e. 48deg past nadir, and left it there - nothing re-drives
      // applyScroll once the entry animation ends until you scroll again.
      if (window.__scrollDrive) window.__scrollDrive();
      // The clock is positioned in BOARD space, so it must be re-derived from the
      // camera AFTER applyScroll has moved it, or the rise trails the moon by a
      // frame. Only during the entry: once that ends the clock stays world-fixed,
      // which is what lets the rig scroll away from it into section 2.
      if (window.__placeClock) window.__placeClock();
    }
    if (window.__glowAngles) window.__glowAngles();
    if (window.__rimTrack) window.__rimTrack();
    if (window.__limbTrack) window.__limbTrack();
    if (window.__dbgTick) window.__dbgTick();
    if (window.__controls) window.__controls.update();
    renderer.render(scene, camera);
    frames++;
    const now = performance.now();
    if(now-fpsT > 1000){ fps = Math.round(frames*1000/(now-fpsT)); frames=0; fpsT=now;
      // Same null guard as say(): the banner build strips #hud, and this one is
      // INSIDE the render loop, so it threw once a second forever rather than once.
      if (hud) hud.textContent = log.join('\n') + `\nfps ${fps}  draws ${renderer.info.render.calls}  tris ${renderer.info.render.triangles}`;
    }
  });
  // free-look for inspection; scroll rig is the real behaviour
  let controls = null;
  if (Q.get('free') === '1') {
    const { OrbitControls } = await import('three/addons/controls/OrbitControls.js');
    controls = new OrbitControls(camera, renderer.domElement);
    controls.enableDamping = true; controls.dampingFactor = 0.08;
    controls.target.set(0,0,0);
    camera.position.set(parseFloat(Q.get('camx') || '0'),
                        parseFloat(Q.get('camy') || '20'),
                        parseFloat(Q.get('camz') || '78'));
    document.getElementById('cx-panels').style.display = 'none';
    document.getElementById('cx-stage').style.display = 'none';
    // park the rig at a chosen point so the lights can be inspected per section
    // while the orbit camera moves independently of it
    if (Q.has('t')) { applyScroll(parseFloat(Q.get('t'))); say(`rig parked at t=${Q.get('t')}`); }
    // orbit mode is an inspection tool, so the hint earns its place there
    document.documentElement.classList.add('cx-showhud');
    const _sh1=document.getElementById('cx-scrollhint'); if(_sh1) _sh1.textContent = 'drag to orbit | scroll to zoom';
    say('orbit controls ON');
  } else {
    if (Q.get('nopanels') === '1') {
      document.getElementById('cx-stage').style.opacity = '0';
      const _sh2=document.getElementById('cx-scrollhint'); if(_sh2) _sh2.style.display='none';
    }
    // Sticky sections all stay in the layout once pinned, and they are transparent,
    // so without this you read the hero and the numerology cards on top of each
    // other. Panel i owns the scroll window [i, i+1) in viewport units; the fade
    // runs over the last/first FADE of that window so only one is ever legible.
    // Opacity goes on the .panel, never on its .frame - the hero's entry animation
    // already owns #hero's own opacity, and the two multiply.
    const PANELS = [...document.querySelectorAll('#cx-stage .cx-layer')];
    // Windows in viewport units within a panel's own 1.0 slot, u = 0 at its pin.
    //   -0.96 .. -0.04  fades in        (full 0.04 BEFORE it pins)
    //   -0.04 ..  0.06  held
    //    0.06 ..  0.46  fades out
    // and the camera travels 0.08 -> 0.92 of the slot.
    //
    // These USED to be narrow - camera over 0.30..0.62, fades 0.20 and 0.16 wide -
    // because scrolling was free and the rest of the slot was a deliberate HOLD,
    // somewhere to rest while reading. Stepped scrolling removes the hold: a
    // gesture always traverses the whole slot, so a transition packed into a third
    // of it plays at three times the speed of the scrollbar carrying it. That is
    // the mismatch - the bar looked right while everything on screen rushed. Now
    // the windows fill the slot and the two move together.
    //
    // The outgoing panel must still be GONE before the incoming one starts, or the
    // two type layers cross at ~50/50 and read as a double exposure. They now meet
    // exactly at 0.50, where both are 0, so they still never overlap.
    //
    // These fill the ENTIRE slot, edge to edge, and that is not cosmetic. Recorded
    // frame by frame through a real step, the previous 0.06/0.46 and 0.54/0.96
    // spent 446ms at the head of the step and ~250ms at the tail with nothing
    // animating at all, because the pager's ease is slowest at exactly those ends.
    // Section 2's whole entry got 400ms of a 1500ms step and its content rise got
    // 117ms, which is not something a person can see.
    const OUT0 = parseFloat(Q.get('pout')  || '0.00');
    const OUTW = parseFloat(Q.get('poutw') || '0.50');
    const IN0  = parseFloat(Q.get('pin0')  || '0.00');   // full this far before the pin
    const INW  = parseFloat(Q.get('pin')   || '0.50');

    // Sections 2 and 3 move the way the hero does: content rises into place while
    // the hairlines extend outward, and the whole thing plays backwards on the way
    // out. It is driven off each panel's own opacity, so it is already locked to
    // the scroll and needs no second window of its own.
    // Panel 0 is excluded - the hero's pose is owned by poseHero(), which also has
    // to fold in the load-time entry animation.
    // 32, not the hero's 24: a section's rise gets ~350ms where the hero's type
    // gets 1.5s, and over that little time a short travel does not register.
    const SEC_RISE = parseFloat(Q.get('srise') || '32');
    const SECS = PANELS.map((layer, i) => i === 0 ? null : {
      rise:  [...layer.querySelectorAll('.cx-frame > *:not(.cx-hair)')],
      lines: [...layer.querySelectorAll('.cx-hair')],
    });
    const poseSection = (i, p, entering) => {
      const S = SECS[i];
      if (!S) return;
      const s = sectionSettle(p, entering);
      const dy = ((1 - s.text) * SEC_RISE).toFixed(2);
      const sc = s.line.toFixed(4);
      for (const el of S.rise)  el.style.transform = baseTf(el) + `translateY(${dy}px)`;
      // .vt lines are vertical, so they grow along Y; everything else along X.
      for (const el of S.lines)
        el.style.transform = `${el.classList.contains('cx-vt') ? 'scaleY' : 'scaleX'}(${sc})`;
    };

    window.__panelFade = () => {
      const u0 = scrollY / innerHeight;
      PANELS.forEach((el, i) => {
        const u = u0 - i;                                  // 0 = just pinned
        // Which branch produced the opacity IS the direction of travel, and the
        // pose needs it: the easing has to run ease-out whichever way it is going.
        const entering = u < -IN0;
        const op = entering ? clamp01(1 + (u + IN0) / INW)
                            : clamp01(1 - (u - OUT0) / OUTW);
        poseSection(i, op, entering);
        el.style.opacity = op.toFixed(3);
        // visibility, not pointer-events: a descendant that sets pointer-events
        // auto stays hit-testable through an ancestor set to none, so the hidden
        // sections' buttons were still clickable. visibility inherits and blocks.
        el.style.visibility = op > 0.01 ? 'visible' : 'hidden';
        window.__panelOp[i] = op;
      });
      // The hero's exit is its entry run backwards. That lives with the entry
      // code below, which owns the poses; guarded because __panelFade is first
      // called by onScroll() before the entry block has been evaluated.
      if (window.__heroExitPose) window.__heroExitPose(window.__panelOp[0]);
      if (window.__rockVis) window.__rockVis();
      if (window.__applyClockOpacity) window.__applyClockOpacity();
    };
    // Scroll position -> rig t. The camera still LOCKS at each end of the slot, so
    // a section at rest is a held frame and the moon does not creep while you read.
    // Its own window (0.08 -> 0.92) is wider than the fades on both sides, so the
    // descent is already under way before the hero starts leaving and is still
    // settling as the next section arrives.
    const CAM0 = parseFloat(Q.get('cam0') || '0.00');
    const CAMW = parseFloat(Q.get('camw') || '1.00');
    const rigT = (u) => {
      const last = PANEL_T.length - 1;
      const i = Math.max(0, Math.min(Math.floor(u), last - 1));
      const f = clamp01((u - i - CAM0) / CAMW);
      // LINEAR in scroll. The pager already eases the scroll position itself, and
      // an ease here on top of that one compounds: two cubic in-outs in series
      // quadruple the peak rate, which is a camera that barely moves at each end
      // and then lunges through the middle. Everything on screen is now linear in
      // scrollY, so it all tracks the scrollbar exactly.
      return PANEL_T[i] + (PANEL_T[i+1] - PANEL_T[i]) * f;
    };
    window.__rigT = rigT;
    // One driver, used by the scroll listener AND the entry animation. Two copies
    // of this mapping is what parked the rig at the wrong angle on reload.
    window.__scrollDrive = () => {
      applyScroll(rigT(scrollY / innerHeight));
      window.__panelFade();
    };
    if (BANNER) {
      // Pinned to the hero keyframe and left there. __panelFade is replaced
      // rather than suppressed because the real one reads scrollY, which on the
      // home page is the HOST PAGE's scroll - letting it run would fade the
      // banner out as the visitor scrolled past section three of somebody
      // else's page.
      const pinned = () => {
        PANELS.forEach((el, i) => {
          const op = i === 0 ? 1 : 0;
          poseSection(i, op, false);
          el.style.opacity = String(op);
          el.style.visibility = op ? 'visible' : 'hidden';
          window.__panelOp[i] = op;
        });
        if (window.__rockVis) window.__rockVis();
        if (window.__applyClockOpacity) window.__applyClockOpacity();
      };
      window.__panelFade = pinned;
      window.__scrollDrive = () => { applyScroll(PANEL_T[0]); pinned(); };
      window.__scrollDrive();
      addEventListener('resize', () => window.__scrollDrive());
      say('banner mode: rig pinned to the hero, no scroll listener');
    } else {
      const onScroll = () => window.__scrollDrive();
      addEventListener('scroll', onScroll, { passive: true });
      addEventListener('resize', () => window.__panelFade());
      onScroll();
      say(`scroll rig ON (${PANELS.length} pinned sections)`);
    }
  }
  window.__applyScroll = applyScroll;
  window.__controls = controls;

  // ---- entry animation (measured from the 21hrs recording) ----
  //   moon rises   t=0.00 -> 2.40s
  //   hero type    t=0.90 -> 2.40s   fades AND rises 24px (moon leads it by 0.9s)
  //   clock        t=0.90 -> 3.30s   rises 120px, fading over 0.90 -> 2.20s
  //   rules        t=0.90 -> 3.30s   extend outward, locked to the clock
  //
  // Everything leaves the gate together at 0.90. The hero type travels least, so
  // it lands first at 2.40 while the clock is still coming up; the rules finish
  // extending at 3.30, the exact instant the clock settles. That ordering is the
  // point, so ruleDur DEFAULTS to clockDur below rather than repeating the number
  // - retiming the clock retimes the rules with it.
  //
  // clockRise is in BOARD pixels, pushing the clock DOWN from its resting box at
  // t=0, and easing back to 0.
  //
  // WHY 120 AND NOT 360. The first version carried no opacity at all: the clock
  // was solid from frame one and the moon's limb was the only thing hiding it, so
  // it had to start BELOW the lowest point of the silhouette across its whole x
  // band. The limb curves away toward the edges - y=405 at x=696 but y=574 at
  // x=1159 - so the top corners set the bar and that needed 326px minimum. The
  // result travelled a third of the screen and read as coming up from far too low.
  // With clockFade doing the concealing instead, the drop only has to be enough to
  // read as motion, so it is 120: a sixth of the old distance, over a window 1.6x
  // longer. Peak speed drops from about 720 board px/s to 150.
  const ENTRY = { moonDur: 2.40, textStart: 0.90, textDur: 1.50, moonDrop: 30.0,
                  clockStart: parseFloat(Q.get('cstart') || '0.90'),
                  clockDur:   parseFloat(Q.get('cdur')   || '2.40'),
                  // the fade finishes BEFORE the rise does, so the clock settles
                  // solid and then drifts the last few px into place
                  clockFade:  parseFloat(Q.get('cfade')  || '1.30'),
                  clockRise:  parseFloat(Q.get('crise')  || '120'),
                  // the hero type rises too, a sixth of the clock's travel so it
                  // reads as the same move at a different depth
                  textRise:   parseFloat(Q.get('trise')  || '24') };
  ENTRY.ruleStart = parseFloat(Q.get('rstart') || String(ENTRY.clockStart));
  ENTRY.ruleDur   = parseFloat(Q.get('rdur')   || String(ENTRY.clockDur));
  let entryT0 = null;
  // BOTH hero frames are posed. Only one is ever displayed (the media query
  // decides), and posing the hidden one costs nothing - but selecting only the
  // desktop one left the mobile rules parked at scaleX(0) forever.
  const heroFrames = [...document.querySelectorAll('#cx-hero, #cx-m_hero')];
  const frame = heroFrames[0];
  const heroRules = [...document.querySelectorAll('#cx-hero_rules .cx-rule, #cx-m_hero_rules .cx-rule')];
  // The wordmark and the two Mission/Year pairs rise with the clock. Scoped to
  // #hero because .lbl/.val are used in the other panels too. These are inside
  // the scaled .frame, so a translateY in px is already in BOARD units.
  const heroRise = [...document.querySelectorAll(
    '#cx-h_title, #cx-hero .cx-lbl, #cx-hero .cx-val, #cx-m_h_title, #cx-m_hero .cx-lbl, #cx-m_hero .cx-val')];

  // ---- one pose, two drivers -------------------------------------------------
  // Exactly one function writes the hero's entry/exit transforms. entryTick pushes
  // it forward over TIME; __heroExitPose pulls it back over SCROLL. Each supplies
  // a "settled" fraction per channel: 0 = parked (type low, rules retracted, clock
  // sunk), 1 = in place. They are combined with min(), so whichever is further
  // from settled wins. That makes the two callers order-independent, which matters
  // because the render loop runs entryTick and then __panelFade in the same frame
  // and the second would otherwise clobber the first.
  const HIN  = { text: 0, rule: 0, clock: 0 };   // entry  (starts parked)
  const HOUT = { text: 1, rule: 1, clock: 1 };   // exit   (starts settled)
  function poseHero(){
    const pt = Math.min(HIN.text,  HOUT.text);
    const pr = Math.min(HIN.rule,  HOUT.rule);
    const pc = Math.min(HIN.clock, HOUT.clock);
    const dy = ((1 - pt) * ENTRY.textRise).toFixed(2);
    for (const el of heroRise)  el.style.transform = baseTf(el) + `translateY(${dy}px)`;
    for (const el of heroRules) el.style.transform = `scaleX(${pr.toFixed(4)})`;
    window.__clockRise = (1 - pc) * ENTRY.clockRise;
    CDIS.uProg.value = pc;
  }

  // The exit mirrors the entry's CHOREOGRAPHY, not its easing - see sectionSettle,
  // which is the same shape sections 2 and 3 use, so there is one formula and not
  // three copies of it. The hero passes its OWN window ratio rather than the
  // shared default, so retiming the entry retimes the exit with it.
  window.__heroExitPose = (op) => {
    const s = sectionSettle(op, false, ENTRY.textDur / ENTRY.clockDur);
    HOUT.rule = HOUT.clock = s.line;
    HOUT.text = s.text;
    poseHero();
    // __clockRise just changed, and the clock is placed in BOARD space, so it has
    // to be re-derived. Only while the hero is still on screen: past that the
    // clock stays world-fixed, which is what lets the rig pull away from it.
    // applyScroll has already run this frame, so the camera is current.
    if (op > 0.01 && window.__placeClock) window.__placeClock();
  };

  function entryTick(now){
    // Parked while the boot cover is up. entryT0 stays null, so the clock starts
    // at the reveal rather than at whatever moment the render loop happened to
    // begin - which is several seconds earlier, and behind the cover.
    if (window.__bootHold) { entryT0 = null; return true; }
    if (entryT0 === null) entryT0 = now;
    // ?etime=<seconds> freezes the entry at one instant so a frame of it can be
    // measured. Without it the animation is 2.4s of real time and un-samplable.
    const t = Q.has('etime') ? parseFloat(Q.get('etime')) : (now - entryT0) / 1000;
    const mu = THREE.MathUtils.clamp(t / ENTRY.moonDur, 0, 1);
    const tu = THREE.MathUtils.clamp((t - ENTRY.textStart) / ENTRY.textDur, 0, 1);
    window.__entryMoon = (1 - easeOutCubic(mu)) * ENTRY.moonDrop;   // extra altitude, eased out
    const op = easeOutCubic(tu).toFixed(3);
    for (const f of heroFrames) f.style.opacity = op;
    // Type on the hero's own fade window, so it settles at 2.40 - before the
    // clock, which is still rising until 3.30. The rules draw rather than fade:
    // scaleX on a 2px div is a compositor-only change, and at scaleX(0) it has no
    // width, so it needs no opacity to hide.
    const ru = THREE.MathUtils.clamp((t - ENTRY.ruleStart) / ENTRY.ruleDur, 0, 1);
    const cu = THREE.MathUtils.clamp((t - ENTRY.clockStart) / ENTRY.clockDur, 0, 1);
    HIN.text  = easeOutCubic(tu);
    HIN.rule  = easeOutCubic(ru);
    HIN.clock = easeOutCubic(cu);            // its own, longest window
    poseHero();
    if (clockMesh) {
      // Global fade on a shorter window than the rise. applyClockOpacity still
      // multiplies by the panel opacity, so a reload in section 2 or 3 keeps it
      // off screen.
      const fu = THREE.MathUtils.clamp((t - ENTRY.clockStart) / ENTRY.clockFade, 0, 1);
      window.__clockEntry = easeOutCubic(fu);
      applyClockOpacity();
    }
    return t < Math.max(ENTRY.moonDur, ENTRY.textStart + ENTRY.textDur,
                        ENTRY.clockStart + ENTRY.clockDur);
  }
  window.__entryTick = entryTick;
  window.__entryMoon = (Q.get('probe')==='1') ? 0 : ENTRY.moonDrop;
  // Set BEFORE layout() runs, so the very first placement already has the clock
  // sunk. Placing it at rest first would show one frame of it in its final spot.
  // probe never runs entryTick, so nothing would ever pose the hero: the rules
  // would sit at scaleX(0), the type 24px low and the clock sunk and dissolved
  // out. Park the whole entry finished instead. Otherwise seed it parked, before
  // the first paint - posing it settled first shows one frame in its final spot.
  const probing = Q.get('probe') === '1';
  HIN.text = HIN.rule = HIN.clock = probing ? 1 : 0;
  poseHero();
  if (probing) window.__entryTick = null;
  for (const f of heroFrames) f.style.opacity = '0';
  window.__clockEntry = 0;
  clockMesh.material.opacity = 0;

  // ---------------- debug overlay: ?axes=1 ----------------
  // Origin (0,0,0) is the MOON'S CENTRE, which sits 34 units inside the moon, so
  // everything here draws with depthTest off to stay visible through it.
  if (Q.get('axes') === '1') {
    const AX_LEN = parseFloat(Q.get('axlen') || '90');
    const TICK   = parseFloat(Q.get('axtick') || '10');
    const dbg = new THREE.Group(); dbg.renderOrder = 999;
    const mkLine = (pts, col, w) => {
      const g = new THREE.BufferGeometry().setFromPoints(pts);
      const m = new THREE.LineBasicMaterial({ color: col, depthTest: false,
                                              transparent: true, opacity: 0.95 });
      const l = new THREE.Line(g, m); l.renderOrder = 999; return l;
    };
    const V = (x,y,z) => new THREE.Vector3(x,y,z);
    // axes: X red, Y green, Z blue  (+Z is toward the camera)
    dbg.add(mkLine([V(-AX_LEN,0,0), V(AX_LEN,0,0)], 0xff3b30));
    dbg.add(mkLine([V(0,-AX_LEN,0), V(0,AX_LEN,0)], 0x34d058));
    dbg.add(mkLine([V(0,0,-AX_LEN), V(0,0,AX_LEN)], 0x3b82ff));
    // ticks every TICK units, longer every 5th
    for (let d = TICK; d <= AX_LEN; d += TICK) {
      const big = (Math.round(d/TICK) % 5 === 0), t = big ? 3.2 : 1.4;
      for (const sgn of [1,-1]) {
        dbg.add(mkLine([V(sgn*d,-t,0), V(sgn*d,t,0)], 0xff3b30));
        dbg.add(mkLine([V(-t,sgn*d,0), V(t,sgn*d,0)], 0x34d058));
        dbg.add(mkLine([V(-t,0,sgn*d), V(t,0,sgn*d)], 0x3b82ff));
      }
    }
    // origin marker
    const originDot = new THREE.Mesh(
      new THREE.SphereGeometry(1.6, 16, 12),
      new THREE.MeshBasicMaterial({ color: 0xffffff, depthTest: false }));
    originDot.renderOrder = 999; dbg.add(originDot);
    // moon radius ring, so the 34-unit scale is visible
    const ringPts = [];
    for (let i = 0; i <= 96; i++) {
      const a = i/96 * Math.PI*2;
      ringPts.push(V(Math.cos(a)*34, Math.sin(a)*34, 0));
    }
    dbg.add(mkLine(ringPts, 0x8855ff));
    scene.add(dbg);

    // ---- camera arc -------------------------------------------------------
    // Sampled by actually driving the rig, not by re-deriving the maths, so it
    // cannot drift from applyScroll(). Everything it touches is restored after:
    // in ?free=1 the orbit camera is live, and in scroll mode __scrollT and the
    // rock visibility would otherwise be left on the last sample.
    {
      const sPos = camera.position.clone(), sQuat = camera.quaternion.clone();
      const sUp = camera.up.clone(), sT = window.__scrollT || 0;
      const arc = [];
      for (let i = 0; i <= 160; i++) { applyScroll(i/160); arc.push(camera.position.clone()); }
      dbg.add(mkLine(arc, 0x00e5ff));
      // one anchor per section, with a tuft showing where it looks
      for (let k = 0; k < PANEL_T.length; k++) {
        applyScroll(PANEL_T[k]);
        const p = camera.position.clone();
        const fw = V(0,0,-1).applyQuaternion(camera.quaternion).multiplyScalar(12);
        const d = new THREE.Mesh(new THREE.SphereGeometry(0.9,12,10),
          new THREE.MeshBasicMaterial({color:0x00e5ff, depthTest:false}));
        d.position.copy(p); d.renderOrder = 999; dbg.add(d);
        dbg.add(mkLine([p, p.clone().add(fw)], 0x00e5ff));
      }
      applyScroll(sT);
      camera.position.copy(sPos); camera.quaternion.copy(sQuat); camera.up.copy(sUp);
      camera.updateMatrixWorld(true);
    }

    // ---- sun track ---------------------------------------------------------
    // The three per-section sun directions, renormalised the same way the rig
    // does it, so this is exactly where sx/sy/sz and s2*/s3* put the light.
    {
      const anchors = RIG_KEYS.map(k => V(...k.sunW).normalize().multiplyScalar(80));
      dbg.add(mkLine(anchors, 0xffcc44));
      anchors.forEach((a, k) => {
        const d = new THREE.Mesh(new THREE.SphereGeometry(1.1,12,10),
          new THREE.MeshBasicMaterial({color:0xffcc44, depthTest:false, wireframe:true}));
        d.position.copy(a); d.renderOrder = 999; dbg.add(d);
        dbg.add(mkLine([a, a.clone().multiplyScalar(0.55)], 0xffcc44));   // points at the moon
      });
    }

    // live sun marker, and the violet back light
    const sunDot = new THREE.Mesh(new THREE.SphereGeometry(2.2,14,12),
      new THREE.MeshBasicMaterial({color:0xffcc44, depthTest:false}));
    sunDot.renderOrder = 999; scene.add(sunDot);
    const sunRay = mkLine([V(0,0,0),V(0,0,0)], 0xffcc44); scene.add(sunRay);
    if (window.__back) {
      const b = window.__back.position.clone();
      const bd = new THREE.Mesh(new THREE.SphereGeometry(1.6,12,10),
        new THREE.MeshBasicMaterial({color:0xb566ff, depthTest:false, wireframe:true}));
      bd.position.copy(b); bd.renderOrder = 999; dbg.add(bd);
      dbg.add(mkLine([b, V(0,0,0)], 0xb566ff));
    }

    // markers that follow the rocks and their virtual lights.
    // One per PLACED rock, not a hardcoded 2: the watch section's pair was being
    // skipped silently by the !markers[i] guard in the tick below.
    const markers = [];
    for (let i = 0; i < HERO_ROCKS.length; i++) {
      const rm = new THREE.Mesh(new THREE.SphereGeometry(0.22,10,8),
        new THREE.MeshBasicMaterial({color:0x00e5ff, depthTest:false, wireframe:true}));
      const lm = new THREE.Mesh(new THREE.SphereGeometry(0.34,10,8),
        new THREE.MeshBasicMaterial({color:0xffd60a, depthTest:false, wireframe:true}));
      const fm = new THREE.Mesh(new THREE.SphereGeometry(0.30,10,8),
        new THREE.MeshBasicMaterial({color:0xff7a1a, depthTest:false, wireframe:true}));
      rm.renderOrder = lm.renderOrder = fm.renderOrder = 999;
      scene.add(rm); scene.add(lm); scene.add(fm);
      markers.push({rm, lm, fm, link: mkLine([V(0,0,0),V(0,0,0)], 0xffd60a),
                    flink: mkLine([V(0,0,0),V(0,0,0)], 0xff7a1a)});
      scene.add(markers[i].link); scene.add(markers[i].flink);
    }
    const dbgBox = document.createElement('div');
    dbgBox.style.cssText = 'position:fixed;right:12px;bottom:12px;z-index:9;'+
      'font:11px/1.55 ui-monospace,Menlo,monospace;color:#cfe;background:rgba(6,4,14,.82);'+
      'padding:9px 11px;border:1px solid #3a2a5e;border-radius:4px;white-space:pre;pointer-events:none';
    document.body.appendChild(dbgBox);
    const f = v => `${v.x>=0?' ':''}${v.x.toFixed(1)}, ${v.y>=0?' ':''}${v.y.toFixed(1)}, ${v.z>=0?' ':''}${v.z.toFixed(1)}`;
    window.__dbgTick = () => {
      const lines = [];
      lines.push('AXES  X red   Y green   Z blue');
      lines.push('origin (0,0,0) = moon centre  [white dot]');
      lines.push(`moon radius 34  [violet ring]   tick ${TICK}u`);
      lines.push(`camera      ${f(camera.position)}`);
      lines.push(`scroll t    ${(window.__scrollT||0).toFixed(3)}`);
      if (window.__sun) {
        const sp = window.__sun.position;
        sunDot.position.copy(sp);
        sunRay.geometry.setFromPoints([sp.clone(), sp.clone().multiplyScalar(0.42)]);
        const n = sp.clone().normalize();
        lines.push(`sun    ${f(n)}  x80   int ${window.__sun.intensity.toFixed(2)}  [gold]`);
        lines.push('  track = 3 gold rings, one per section');
      }
      if (window.__back) lines.push(`back   ${f(window.__back.position)}  int ${window.__back.intensity}  [violet]`);
      lines.push('camera arc [cyan line], section anchors [cyan dots + tufts]');
      HERO_ROCKS.forEach((h,i) => {
        const o = byName(h.mesh); if(!o || !markers[i]) return;
        // a marker for a rock its panel has hidden is just clutter floating in space
        const on = o.visible;
        markers[i].rm.visible = markers[i].lm.visible = markers[i].link.visible =
          markers[i].fm.visible = markers[i].flink.visible = on;
        if (!on) { lines.push(`rock ${i+1}  ${h.mesh}  (panel ${h.pi+1}, hidden)`); return; }
        markers[i].rm.position.copy(o.position);
        markers[i].lm.position.copy(VLIGHTS[i].pos);
        markers[i].link.geometry.setFromPoints([o.position.clone(), VLIGHTS[i].pos.clone()]);
        markers[i].fm.position.copy(VLIGHTS[i].fpos);
        markers[i].flink.geometry.setFromPoints([o.position.clone(), VLIGHTS[i].fpos.clone()]);
        const behind = VLIGHTS[i].pos.clone().sub(o.position).length();
        const front  = VLIGHTS[i].fpos.clone().sub(o.position).length();
        const anchorCam = VLIGHTS[i].camAt || camera.position;
        const camD   = anchorCam.distanceTo(o.position);
        const fSide  = anchorCam.distanceTo(VLIGHTS[i].fpos) < camD ? 'camera side' : 'WRONG SIDE';
        lines.push(`rock ${i+1}  ${h.mesh}  (panel ${h.pi+1})`);
        lines.push(`  pos  ${f(o.position)}   [cyan]`);
        lines.push(`  cl${i+1}   ${f(VLIGHTS[i].pos)}   int ${VLIGHTS[i].int}  [yellow]`);
        lines.push(`       ${behind.toFixed(2)}u behind, scale ${o.scale.x.toFixed(3)}`);
        lines.push(`  cl${i+1}f  ${f(VLIGHTS[i].fpos)}   int ${VLIGHTS[i].fint}  [orange]`);
        lines.push(`       ${front.toFixed(2)}u in front, ${fSide}`);
      });
      dbgBox.textContent = lines.join('\n');
    };
  }

  layout();
  say('render loop running');
  window.__spikeReady = true;
  // Two frames, not zero: __spikeReady only means main() returned. The first rAF
  // is the frame the render loop draws the settled scene in, the second is after
  // it has been composited - lifting the cover before that shows a blank canvas.
  // armReveal adds the banner's "and only once it is on screen" on top.
  armReveal();
}

main().catch(e=>{ say('ERROR: '+e.message); console.error(e); window.__spikeError = String(e); });


// ---- registration modal -----------------------------------------------------
// Opened from "Register Interest" (and the "scroll down to register" cue). The
// watch section stays pinned behind it and the 3D rig is untouched, so closing
// puts you back exactly where you were.
// Validation and states only. There is NO endpoint yet: submitRegistration() is
// the single place to wire one up (Shopify customer, Klaviyo, a sheet - undecided),
// and until it exists the button reports the payload and refuses to claim success.
(function(){
  const modal = document.getElementById('cx-modal');
  const card  = document.getElementById('cx-modal_card');
  const btn   = document.getElementById('cx-p4_btn');
  if (!modal || !btn) return;

  const f = {
    name:  modal.querySelector('[name=name]'),
    email: modal.querySelector('[name=email]'),
    phone: modal.querySelector('[name=phone]'),
  };
  const msg = document.getElementById('cx-p4_msg');

  function clear(){
    Object.values(f).forEach(el => {
      el.classList.remove('cx-field-bad');
      el.removeAttribute('aria-invalid');
    });
    if (msg) { msg.textContent = ''; msg.classList.remove('cx-on'); }
  }
  // Returns false so a validator can `return mark(...)` and read as a rejection.
  function mark(el, text, focus){
    clear();
    el.classList.add('cx-field-bad');
    el.setAttribute('aria-invalid', 'true');
    if (msg) { msg.textContent = text; msg.classList.add('cx-on'); }
    if (focus) el.focus();
    return false;
  }
  const bad = (el, text) => mark(el, text, true);

  // ---- open / close ----
  let lastFocus = null;
  function open(){
    if (!modal.hidden) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    clear();                       // never reopen onto a stale error from last time
    // one frame before adding .on, or the transition has nothing to animate from
    requestAnimationFrame(() => { modal.classList.add('cx-on'); f.name.focus(); });
    document.documentElement.style.overflow = 'hidden';   // freeze the scroll rig
  }
  function close(){
    if (modal.hidden) return;
    modal.classList.remove('cx-on');
    document.documentElement.style.overflow = '';
    setTimeout(() => { modal.hidden = true; }, 280);       // match the CSS transition
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  window.__openRegister = open;
  window.__closeRegister = close;

  document.getElementById('cx-modal_x').addEventListener('click', close);
  document.getElementById('cx-modal_bg').addEventListener('click', close);
  addEventListener('keydown', e => {
    if (e.key === 'Escape' && !modal.hidden) close();
    // keep tab inside the dialog while it is up
    if (e.key === 'Tab' && !modal.hidden) {
      const items = card.querySelectorAll('button,input,[tabindex="0"]');
      const first = items[0], last = items[items.length-1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // A SELECTOR string, not an array of bare ids. The Shopify port prefixes every
  // id, and it can only rewrite ids it can recognise - inside a '#...' selector or
  // a literal getElementById('cx-x'). An array of bare names passed through a
  // variable is invisible to it, so these four silently kept their unprefixed
  // names in the theme and the modal could never open.
  document.querySelectorAll('#cx-p3_btn, #cx-p2_note, #cx-m_p2_note, #cx-m_p3_btn')
    .forEach(el => el.addEventListener('click', open));

  // ---- validation ----------------------------------------------------------
  // This runs twice: here, where it can be helpful about WHAT is wrong, and again
  // in the Apps Script, because the /exec URL is public and anything at all can
  // POST to it. The client half is UX; the server half is what actually keeps the
  // sheet clean.

  // Not the RFC grammar. That accepts quoted local parts and bare-IP domains no
  // customer will ever type, while the old loose pattern let "a@b.co m"-shaped
  // junk straight through. This is the shape of a DELIVERABLE address: a local
  // part, a dotted domain, an alphabetic TLD of 2+.
  // Two escapes in here are not optional, and neither is about the pattern:
  //   \/    an unescaped / inside [...] is legal and engines parse it fine, but
  //         editors and linters lex it as the regex terminator and report the
  //         rest of the file as an unterminated literal.
  //   \x27  the apostrophe (a legal local-part character - o'brien@...). Written
  //         raw it is a quote to build_liquid.py's string-literal rewriter, which
  //         would pair it with the next one and rewrite whatever fell between.
  //         It survives today only because both apostrophes sit on this one line.
  const EMAIL = /^[A-Za-z0-9!#$%&\x27*+\/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&\x27*+\/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,24}$/;

  // A name, not a keyboard mash. Two letters minimum and no digits - "1", "..",
  // "asdf1234" are the shapes a public list fills up with.
  const NAME_OK = s => s.length >= 2 && s.length <= 80 &&
                       (s.match(/[\p{L}]/gu) || []).length >= 2 && !/\d/.test(s);

  // Damerau-Levenshtein, not plain Levenshtein: "gmial" -> "gmail" is a single
  // transposition and the single most common address typo there is. Plain
  // Levenshtein scores that 2 and a threshold of 1 would miss it entirely.
  function editDist(a, b){
    if (a === b) return 0;
    const m = a.length, n = b.length;
    let pp = null, p = Array.from({length: n + 1}, (_, j) => j), cur;
    for (let i = 1; i <= m; i++){
      cur = new Array(n + 1); cur[0] = i;
      for (let j = 1; j <= n; j++){
        cur[j] = Math.min(p[j] + 1, cur[j-1] + 1,
                          p[j-1] + (a[i-1] === b[j-1] ? 0 : 1));
        if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1])
          cur[j] = Math.min(cur[j], pp[j-2] + 1);
      }
      pp = p; p = cur;
    }
    return p[n];
  }
  // The domains that carry most of an Indian consumer list. A typo in one of these
  // is a lead that silently never arrives, so it is worth one confirm step - but a
  // WARNING, never a block: press submit again and it sends exactly as typed.
  const DOMAINS = ['gmail.com','googlemail.com','yahoo.com','yahoo.co.in','yahoo.in',
                   'outlook.com','hotmail.com','live.com','icloud.com','me.com',
                   'rediffmail.com','proton.me','protonmail.com'];
  function suggestDomain(email){
    const at = email.lastIndexOf('@');
    if (at < 0) return '';
    const local = email.slice(0, at), dom = email.slice(at + 1).toLowerCase();
    if (DOMAINS.indexOf(dom) >= 0) return '';
    for (const d of DOMAINS) if (editDist(dom, d) === 1) return local + '@' + d;
    return '';
  }

  // AC's launch list is India-first but the brand is not, so: a plain 10-digit
  // Indian mobile - with or without 0 / 91 / +91 in front - is held to the 6-9
  // first-digit rule the DoT actually allocates, and anything written in
  // international form with a + is accepted at E.164 length. That rejects
  // 1234567890 and 0000000000 without turning away a real foreign number.
  // Returns E.164, or null if it is not a number anyone could ring.
  function normPhone(raw){
    const plus = /^\s*\+/.test(raw);
    let d = (String(raw).match(/\d/g) || []).join('');
    if (!d) return null;
    if (/^(\d)\1+$/.test(d)) return null;
    if (d.length === 13 && d.slice(0, 3) === '091') d = d.slice(3);
    else if (d.length === 12 && d.slice(0, 2) === '91') d = d.slice(2);
    else if (d.length === 11 && d[0] === '0') d = d.slice(1);
    if (d.length === 10) return /^[6-9]/.test(d) ? '+91' + d : null;
    if (plus && d.length >= 8 && d.length <= 15) return '+' + d;
    return null;
  }

  const MSG = {
    name:  'Please enter your name.',
    email: 'That email address does not look right.',
    phone: 'That phone number does not look right — 10 digits, or + and your country code.',
  };

  // The address a domain hint has already been overridden for. Keyed to the value
  // so editing the address re-arms the hint rather than silently disarming it.
  let typoOK = '';

  // Returns the cleaned payload, or false having already flagged the field.
  function validate(){
    clear();
    const name = f.name.value.trim().replace(/\s+/g, ' ');
    if (!name)          return bad(f.name, 'Please enter your name.');
    if (!NAME_OK(name)) return bad(f.name, MSG.name);

    const email = f.email.value.trim();
    if (!email)                                 return bad(f.email, 'Please enter your email address.');
    if (email.length > 254 || !EMAIL.test(email)) return bad(f.email, MSG.email);
    const hint = suggestDomain(email);
    if (hint && typoOK !== email.toLowerCase()) {
      typoOK = email.toLowerCase();
      return bad(f.email, 'Did you mean ' + hint + '? Submit again to send it as typed.');
    }

    if (!f.phone.value.trim()) return bad(f.phone, 'Please enter your phone number.');
    const phone = normPhone(f.phone.value);
    if (!phone)                return bad(f.phone, MSG.phone);

    return { name: name, email: email, phone: phone };
  }

  // Flag on blur so a mistake surfaces while the field is still the one in mind,
  // but never steal focus back - the visitor is on their way to the next field.
  // Empty is not an error yet; that is submit's job.
  function checkOne(el){
    const v = el.value.trim();
    if (!v) return;
    if (el === f.name  && !NAME_OK(v.replace(/\s+/g, ' '))) mark(el, MSG.name, false);
    if (el === f.email && !EMAIL.test(v))                   mark(el, MSG.email, false);
    if (el === f.phone && !normPhone(v))                    mark(el, MSG.phone, false);
  }
  Object.values(f).forEach(el => {
    el.addEventListener('blur', () => checkOne(el));
    // Typing anywhere clears everything: one visible message at a time, and it is
    // never a stale one about a field already corrected.
    el.addEventListener('input', clear);
  });

  // The endpoint is configuration, never a constant: in the theme it arrives from
  // the section's schema setting, standalone it can be passed as ?endpoint=.
  const CFG = window.__cosmicConfig || {};
  // Its OWN URLSearchParams. `Q` lives inside main() and `QP` at module scope, and
  // this block is a separate plain <script> - neither is visible here. Referencing
  // Q threw at IIFE-evaluation time, which silently took out every listener below
  // it: the close button (attached earlier) worked, the submit button never bound.
  const ENDPOINT = (CFG.endpoint ||
                    new URLSearchParams(location.search).get('endpoint') || '').trim();

  const form    = document.getElementById('cx-p4_form');
  const iframe  = document.getElementById('cx-p4_iframe');
  const pageFld = document.getElementById('cx-p4_page');

  // Posts the form into the hidden iframe and resolves on its load event.
  // form.submit() is used rather than a submit button because the control is a
  // div[role=button]; calling it directly also skips the submit event, so the
  // validation above stays the single gate.
  function submitRegistration(){
    return new Promise((resolve, reject) => {
      if (!ENDPOINT) return reject(new Error('no endpoint configured'));
      if (!form || !iframe) return reject(new Error('form markup missing'));
      form.action = ENDPOINT;
      if (pageFld) pageFld.value = location.href;

      let settled = false;
      const finish = (err) => {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        iframe.removeEventListener('load', onLoad);
        err ? reject(err) : resolve();
      };
      const onLoad = () => finish(null);
      // A cross-origin response is opaque - we cannot read the iframe body, so a
      // load event is the only success signal available. Apps Script answers
      // quickly; 25s matches the warranty form and only exists so a dead endpoint
      // eventually releases the button instead of hanging it forever.
      const timer = setTimeout(() => finish(new Error('timed out')), 25000);
      iframe.addEventListener('load', onLoad);
      form.submit();
    });
  }

  const cookie = (k) => {
    const m = document.cookie.match('(^|;)\\s*' + k + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m[2]) : '';
  };

  /* One id, both paths. The browser pixel fires Lead with this as its eventID and
     the Apps Script sends the same value as the CAPI event_id; Meta then treats
     them as ONE conversion. Without it a registration counts twice and the ad set
     optimises against inflated numbers. */
  const newEventId = () =>
    'cosmic-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);

  /* The theme cannot call fbq: AC's Meta tracking runs through Shopify Custom
     Pixels, which are sandboxed and have no access to this window. Publishing a
     custom event is the supported bridge - a custom pixel subscribes to
     'cosmic_register' on the other side and fires the actual Lead. */
  function publishRegister(eid){
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish('cosmic_register', {
          event_id: eid, source: 'cosmic-prebuzz', content_name: 'Cosmic Prebuzz',
        });
      }
    } catch (e) { /* never let tracking break the confirmation */ }
  }

  let busy = false;
  async function submit(){
    if (busy) return;
    const payload = validate();
    if (!payload) return;

    // The form posts the VISIBLE inputs, so the cleaned values have to land back
    // in them: collapsed whitespace in the name and the phone in E.164, so the
    // sheet gets one shape rather than nine ways of writing the same number.
    f.name.value  = payload.name;
    f.email.value = payload.email;
    f.phone.value = payload.phone;

    // Generated BEFORE the post, because the same id has to travel with the form.
    // Literal getElementById per field, NOT a helper taking the id as a string.
    // The Shopify port only rewrites ids it can see in a '#...' selector or a
    // literal getElementById('cx-x'); an id passed through a variable keeps its
    // unprefixed name and silently resolves to nothing. The build guard rejects
    // this pattern outright - it is how the modal's triggers once shipped dead.
    const eid = newEventId();
    const set = (el, v) => { if (el) el.value = v; };
    set(document.getElementById('cx-p4_eid'), eid);
    set(document.getElementById('cx-p4_fbp'), cookie('_fbp'));
    set(document.getElementById('cx-p4_fbc'), cookie('_fbc'));
    set(document.getElementById('cx-p4_ua'),  navigator.userAgent || '');

    busy = true; const label = btn.textContent; btn.textContent = 'Sending\u2026';
    try {
      await submitRegistration();
      // Only on success. Firing on click would count registrations that never
      // reached the sheet, and this is about to become the ad set's optimisation
      // event - a conversion Meta is told about but nobody actually completed is
      // worse than no signal at all.
      publishRegister(eid);
      btn.textContent = 'You are on the list';
      Object.values(f).forEach(el => { el.value = ''; el.disabled = true; });
      setTimeout(close, 1600);
    } catch (e) {
      btn.textContent = label;
      // Say so. Silently reverting the label looked like a dead button, and the
      // visitor's only other clue was the console.
      if (msg) { msg.textContent = 'Could not send just now. Please try again.';
                 msg.classList.add('cx-on'); }
      console.warn('registration not sent:', e.message, payload);
      busy = false;
    }
  }
  btn.addEventListener('click', submit);
  btn.addEventListener('keydown', e => { if (e.key==='Enter'||e.key===' '){ e.preventDefault(); submit(); } });
  Object.values(f).forEach(el =>
    el.addEventListener('keydown', e => { if (e.key === 'Enter') submit(); }));
})();


// ---- ambient sound + the waveform in the corner glyph -----------------------
// Synthesised, not a file. The page already measures ~2.8 MB against a 2.74 MB
// benchmark on 92.5% mobile traffic; an ambient bed would add megabytes for one
// decorative loop. This is a few oscillators and costs nothing to download.
// The glyph's line IS the waveform: flat when muted, which is the original mark.
(function(){
  const glyph = document.getElementById('cx-hud_glyph');
  const wave  = document.getElementById('cx-hud_wave');
  const hint  = document.getElementById('cx-hud_sound_hint');
  if (!glyph || !wave) return;

  const W = 29, H = 29, MID = H / 2, N = 34;
  const flat = () => Array.from({length: N}, (_, i) => `${(i/(N-1))*W},${MID}`).join(' ');
  wave.setAttribute('points', flat());

  let ctx = null, analyser = null, data = null, master = null, on = false, raf = 0;

  function build(){
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = 0;                       // faded in, never a jump-scare
    const lp = ctx.createBiquadFilter();
    lp.type = 'lowpass'; lp.frequency.value = 900; lp.Q.value = 0.6;
    analyser = ctx.createAnalyser();
    analyser.fftSize = 256;
    data = new Uint8Array(analyser.fftSize);

    // A drone on an open fifth/ninth stack - unresolved, which is the "space"
    // part. Detuned pairs beat slowly so the texture never sits still.
    [55, 82.5, 110, 164.66, 220].forEach((f, i) => {
      [-6, 6].forEach(cents => {
        const o = ctx.createOscillator();
        o.type = i > 2 ? 'sine' : 'triangle';
        o.frequency.value = f; o.detune.value = cents;
        const g = ctx.createGain();
        g.gain.value = 0.13 / (i + 1);
        const lfo = ctx.createOscillator();
        lfo.frequency.value = 0.03 + i * 0.017 + (cents > 0 ? 0.011 : 0);
        const amt = ctx.createGain();
        amt.gain.value = g.gain.value * 0.8;
        lfo.connect(amt).connect(g.gain);
        o.connect(g).connect(lp);
        o.start(); lfo.start();
      });
    });
    const sweep = ctx.createOscillator();        // slow drift across the whole bed
    sweep.frequency.value = 0.021;
    const sweepAmt = ctx.createGain();
    sweepAmt.gain.value = 420;
    sweep.connect(sweepAmt).connect(lp.frequency);
    sweep.start();
    lp.connect(analyser).connect(master).connect(ctx.destination);
  }

  function draw(){
    raf = requestAnimationFrame(draw);
    analyser.getByteTimeDomainData(data);
    const step = Math.floor(data.length / N);
    let pts = '';
    for (let i = 0; i < N; i++){
      const edge = Math.sin((i / (N - 1)) * Math.PI);   // taper to meet the circle
      const v = ((data[i * step] - 128) / 128) * (H * 0.42) * edge;
      pts += `${(i/(N-1))*W},${(MID + v).toFixed(2)} `;
    }
    wave.setAttribute('points', pts.trim());
  }

  async function toggle(){
    if (!ctx) build();
    if (ctx.state === 'suspended') await ctx.resume();   // autoplay policy
    on = !on;
    glyph.classList.toggle('cx-on', on);
    const t = ctx.currentTime;
    master.gain.cancelScheduledValues(t);
    master.gain.setValueAtTime(master.gain.value, t);
    master.gain.linearRampToValueAtTime(on ? 0.22 : 0.0, t + (on ? 1.6 : 0.6));
    if (on && !raf) draw();
    if (!on) setTimeout(() => {
      if (on) return;
      cancelAnimationFrame(raf); raf = 0;
      wave.setAttribute('points', flat());
    }, 700);
    hint.classList.remove('cx-show');
  }

  glyph.addEventListener('click', toggle);
  glyph.addEventListener('keydown', e => {
    if (e.key === 'Enter' || e.key === ' '){ e.preventDefault(); toggle(); }
  });
  // the board promises "best experienced with sound", so point at the control
  // once rather than autoplaying at someone
  setTimeout(() => { if (!on) hint.classList.add('cx-show'); }, 2600);
  setTimeout(() => hint.classList.remove('cx-show'), 8000);
})();


// ---- stepped scrolling ------------------------------------------------------
// One gesture moves exactly one section, and the whole transition - the camera
// travel AND the incoming content's fade - plays out inside that single move.
// Before this you could stop anywhere, which is what left you landed on the moon
// with the text not yet up and needing a second scroll to finish the job.
//
// CSS scroll-snap cannot do it, and that is measured rather than assumed. With
// these 818px panels, `scroll-snap-type:y mandatory` plus `scroll-snap-stop:
// always`, one wheel gesture from the top gave:
//     200..1000px delta -> sprang all the way back to 0, nothing happened
//     1500px            -> section 1
//     2000..3000px      -> section 2, one skipped; snap-stop did not hold it
// Until a gesture passes half a viewport the nearest snap point is still the one
// you started on, so anything short of ~1000px is refused and anything long
// overshoots. So this drives the scroll itself and free scrolling is suppressed.
(() => {
  const panels = document.getElementById('cx-panels');
  const modal  = document.getElementById('cx-modal');
  // The home-page banner has no #panels, so this already bails - but say it
  // outright too. This script drives window.scrollTo; the one thing it must
  // never do is run on a page it does not own.
  if (window.__banner) return;
  if (!panels) return;
  const N = panels.querySelectorAll('.cx-panel').length;
  if (!N) return;
  const DUR   = parseFloat(new URLSearchParams(location.search).get('stepms')) || 1800;
  const TRIG  = 40;      // accumulated wheel delta that counts as a real gesture
  // ...but a SECOND step out of the same unbroken stream costs far more. At a flat
  // 40 a slow 90px drag stepped twice, which is two sections for less than one
  // mouse notch of travel. The first step in a gesture stays cheap so a light
  // flick still works; only continuing without ever pausing has to pay this.
  const TRIG_CONT = 150;
  const NEWGST = 220;    // a pause this long starts a fresh accumulation
  const RISE  = 1.25;    // delta growing by this much = a fresh push
  const FALL  = 0.95;    // delta shrinking past this = momentum dying
  const SWIPE = 40;      // px below which a touch is a tap, not a swipe
  const MINSTEP = 450;   // ms between step STARTS, the only brake on retargeting

  // ?free=1 and ?nopanels=1 hide #panels and hand the wheel to OrbitControls, so
  // the pager has to keep its hands off entirely in those modes.
  const live = () => panels.style.display !== 'none' &&
                     document.documentElement.scrollHeight > innerHeight + 4;
  const modalOpen = () => modal && !modal.hidden;

  let idx = 0, busy = false, lastGesture = 0, stepAt = 0, animId = 0;
  // Smoothstep, not cubic ease-in-out. Everything on screen is keyed to scroll
  // POSITION, so this curve decides how much wall-clock time each phase of the
  // transition gets. Cubic in-out peaks at 2.0x the average rate and crawls at
  // both ends, which spent a third of every step going nowhere and then rushed
  // the whole handover through the middle. Smoothstep peaks at 1.5x, so the step
  // still eases in and out but the motion is spread far more evenly across it.
  const ease = u => u * u * (3 - 2 * u);

  function goTo(i, dur = DUR) {
    idx = Math.max(0, Math.min(N - 1, i));
    const from = scrollY, to = idx * innerHeight;
    if (Math.abs(to - from) < 1) return;
    busy = true;
    stepAt = performance.now();
    // A retarget starts a SECOND animation while the first is still running, and
    // two rAF loops writing scrollY fight each other. The token retires the old one.
    const mine = ++animId;
    const t0 = performance.now();
    (function step(now){
      if (mine !== animId) return;
      const u = dur > 0 ? Math.min((now - t0) / dur, 1) : 1;
      // behavior:'instant', NOT the two-arg scrollTo. The two-arg form obeys the
      // CSS `scroll-behavior`, and AC's bootstrap.min.css sets :root to smooth.
      // That made the browser start a fresh smooth animation toward EVERY frame's
      // target, fighting this loop - the page crawled or stuck instead of stepping.
      scrollTo({ top: from + (to - from) * ease(u), left: 0, behavior: 'instant' });
      if (u < 1) return requestAnimationFrame(step);
      // Unlock immediately. The momentum tail is rejected by its SHAPE in the
      // wheel handler, not by waiting it out here - every timing-based attempt
      // either locked the user out while they kept scrolling, or unlocked mid-
      // tail and let the dregs steal a second step.
      busy = false;
    })(performance.now());
  }

  // While a step is in flight, count from its TARGET, not from the live scroll
  // position - mid-animation scrollY rounds to whichever section is nearer and
  // a second push would land back where it started. Otherwise re-derive from the
  // scroll position rather than trusting the counter, since a reload, a resize or
  // an anchor can move the page underneath it.
  const stepBy = d => goTo((busy ? idx : Math.round(scrollY / innerHeight)) + d);

  // A push arriving mid-step RETARGETS to the next section instead of being
  // dropped. Dropping it was the real reason scrolls went missing: a step lasts
  // DUR ms, scrolling again inside that window is the natural thing to do, and
  // every one of those gestures was being discarded. MINSTEP is the only floor -
  // without it a continuously-spun wheel would retarget on every event and race
  // through the page. Momentum cannot retarget, because it is decaying.
  const mayStep = () => performance.now() - stepAt >= MINSTEP;

  // Wheel deltas are ACCUMULATED rather than acted on one at a time. A single
  // per-event threshold cannot work for both input devices: one mouse notch is
  // ~100px while a slow trackpad drag arrives as a stream of 1-3px, so any floor
  // high enough to reject a dying momentum tail also rejects a real slow scroll.
  // Summing handles both, and the accumulator is zeroed on anything that reads as
  // coasting so a tail cannot bank credit and spend it later.
  //
  // A momentum tail is identified by its SHAPE, not its size: it DECAYS
  // monotonically, where a deliberate scroll holds or grows. Comparing each
  // delta against the gesture's PEAK looked equivalent and was not - after a
  // firm flick the peak stayed high, so the next, gentler push was entirely
  // below it and got thrown away as tail. That is what kept eating scrolls.
  // Tracking the trend instead never rejects a fresh push, because a fresh push
  // is by definition a rise. RISE/FALL leave a dead band between them so a noisy
  // stream cannot flap.
  let acc = 0, accT = 0, prevMag = 0, decaying = false, stepped = false;
  addEventListener('wheel', (e) => {
    if (modalOpen() || !live()) return;
    e.preventDefault();                       // no free-form scroll between sections
    const now = performance.now();
    if (now - accT > NEWGST) { acc = 0; prevMag = 0; decaying = false; stepped = false; }
    accT = lastGesture = now;
    const mag = Math.abs(e.deltaY);
    if (mag > prevMag * RISE)      decaying = false;   // pushed again
    else if (mag < prevMag * FALL) decaying = true;    // coasting
    prevMag = mag;
    if (decaying) { acc = 0; return; }
    acc += e.deltaY;
    if (Math.abs(acc) < (stepped ? TRIG_CONT : TRIG)) return;
    // Hold the accumulation rather than discarding it, so a gesture that earns a
    // step during MINSTEP fires the moment the brake lifts instead of being lost.
    if (!mayStep()) return;
    const d = acc > 0 ? 1 : -1;
    acc = 0; stepped = true;
    stepBy(d);
  }, { passive: false });

  addEventListener('keydown', (e) => {
    if (modalOpen() || !live()) return;
    const tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
    let d = 0;
    if (e.key === 'ArrowDown' || e.key === 'PageDown' || e.key === ' ') d = 1;
    else if (e.key === 'ArrowUp' || e.key === 'PageUp') d = -1;
    else if (e.key === 'Home') { e.preventDefault(); goTo(0); return; }
    else if (e.key === 'End')  { e.preventDefault(); goTo(N - 1); return; }
    else return;
    e.preventDefault();
    lastGesture = performance.now();
    if (mayStep()) stepBy(d);          // a held arrow key retargets, it does not race
  });

  let ty = null;
  addEventListener('touchstart', (e) => {
    if (modalOpen() || !live()) return;
    ty = e.touches[0].clientY;
  }, { passive: true });
  // Native touch scrolling has to go too, or a flick free-scrolls most of the way
  // through a section before touchend ever reaches the pager.
  addEventListener('touchmove', (e) => {
    if (modalOpen() || !live()) return;
    e.preventDefault();
  }, { passive: false });
  addEventListener('touchend', (e) => {
    if (modalOpen() || !live() || ty === null) return;
    const dy = ty - e.changedTouches[0].clientY;
    ty = null;
    lastGesture = performance.now();
    // A swipe is discrete - there is no momentum tail to filter, since touchmove
    // is prevented - so it only has to clear MINSTEP to retarget mid-step.
    if (Math.abs(dy) < SWIPE || !mayStep()) return;
    stepBy(dy > 0 ? 1 : -1);
  }, { passive: true });

  // A reload restores the previous scroll offset, which can sit between sections.
  const align = () => { if (live()) goTo(Math.round(scrollY / innerHeight), 0); };
  if (document.readyState === 'complete') align(); else addEventListener('load', align);
  addEventListener('resize', () => { if (live() && !busy) scrollTo({ top: idx * innerHeight, left: 0, behavior: 'instant' }); });
})();
